import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import {
  BusinessNumberSearchResult,
  Application,
  ApplicationKybQueueResponse,
  ApplicationKybRunFilters,
  RetryApplicationKybRunsResult,
  AmlDashboardFilters,
  AmlDashboardResponse,
  AmlDashboardSort,
  AmlOfficerCandidate,
  GetAmlOfficerCandidatesFn,
  UpdateAmlOfficerForApplication,
  UpdateApplicationAmlOfficerFn,
  ApplicationDocumentsData,
  ApplicationDocumentsTableData,
  ApplicationMonthlyStatistics,
  ApplicationSortTypes,
  ApplicationStatistics,
  ApplicationTypes,
  AzureStorageDocument,
  BrokerOfUser,
  DocumentTag,
  DocumentWorklists,
  DocumentWorklistTableData,
  FetchABRdataByABNResult,
  filesToBase64Files,
  GeoLocation,
  getApplicationStage2,
  getApplicationStatus2,
  GetNewsResult,
  getOrgTypeByEntityText,
  InProgressApplicationStatistics,
  Metadata,
  Quote,
  RatecardDetails,
  SaveApplicationData,
  SaveApplicationResult,
  SaveQuoteResult,
  SearchCompanyByABNResult,
  SearchCompanyResult,
  ServiceabilityCalculationInput,
  ServiceabilityCalculationResult,
  SettledApplicationStatistics,
  SimplifiedApplication,
  SubmitApplicationResult,
  UpdateApplicationData,
  User,
  UserSelectionValue,
  GetRateCardDetailsFn,
  Disbursement,
  SyncSupplierBankDetailsBody,
  SyncDisbursementBody,
  BpayValidationData,
  UpdateApplicationStageBody,
  SettleLoanBody,
  SyncPrivateSellerBankDetailsBody,
  DirectCreditInstitutionSearchResult,
  SyncDepositPaidToBody,
  LocalBankAccountDetailValue,
  GenerateApprovalNoticeBody,
  GenerateContractResponse,
  SendApprovalNoticeEmailBody,
  DeleteContractBody,
  ApplicationOwner,
  SfAccountDetails,
  TaxInvoiceDetails,
  GetRbaRateFn,
  LvrCalculatorValue,
  LvrCalculatorInput,
  DscrCalculatorValue,
  DscrCalculatorInput,
  VerimotoAssetInspectionData,
  VerimotoCreateInspectionResponse,
  VerimotoInspectionTableDataWithInspectionDetails,
  UpdateApplicationFn,
  UpdateApplicationSfFn,
  AzureStorageContainer,
  GetBankStatementsAnalysisFn,
  IndividualWithResult,
  UserOmitPriviledges,
  PaginationInfo,
  BpayGetBillerByBillerCodeResult,
  BpayValidatePaymentResult,
  SaveBsaCalculatorBody,
  BsaCalculator,
  SortTypes, NewCreditFlowBody, CreditFlow, CreditFlowNodeBody, CreditRuleMappingBody, CreditFlowNode, CreditRuleMapping, CreditFlowDetails, CreditAlert, NewCreditAlertBody,
  CopyCreditFlowBody, CreditRuleItem, NewCreditRuleItemBody,
  PublishCreditFlowBody,
  ConflictedFlowDetail,
  ApplicationWebService, ApplicationCreditFlow, UpdateCreditStatusBody, CreditAuditLog, CreditorWatchReportData, ApplicationApplicant, IndividualDirector,
  GetWebServiceReportResponse, DuplicatedApplication,
  GetBasiqCustomerMappingFn, BasiqCompanyDetailsBody, GetBasiqStatementDataForCompanyFn, BasiqUserCustomerMapping, GetBankStatementAndBasiqDataStatusFn, BankstatementAndBasiqDataStatus,
  UpdateLenderBody, BsaLender, AddLenderBody, DscrCalculatorHistory,
  OverdraftProductApplicationStatistics,
  BasiqReferenceType, BankStatementData,
  DocumentReviewEmailBody,
  UpdateApplicationAnzsicBody,
  UpdateApplicationAnzsicFn,
  UpdateApplicationBorrowerPropertyOwnerBody,
  UpdateApplicationBorrowerPropertyOwnerFn,
  UpdateLoanPurposeBody,
  UpdateLoanPurposeFn,
  UpdateCreditFlowBody,
  RequestMoreInformationBody,
  WithdrawApplicationBody,
  ApplicationCreditOfficer,
  CreditAlertStatus,
  UpdateCreditOfficerBody,
  UpdateSettlementsOfficerForApplication,
  ConnectToOtherCreditFlowBody,
  ClearConnectToOtherCreditFlowBody,
  TestCreditFlowBody,
  TestCreditFlowResponse,
  TestCreditRuleBody,
  TestCreditFlowNodeBody,
  TestCreditRuleItemBody,
  NewWebService,
  HistoricalContract,
  PismoContract,
  GetPismoContractsFn,
  CheckActiveOverdraftAccountDetails,
  CreditFlowConsentBlockPayload,
  CreditApprovalReadiness,
  KybRiskStatus,
  MergeApplicationIndividualsInput,
  MergeApplicationIndividualsResult,
} from '@portal-workspace/grow-shared-library';
import { ApiResponse, Base64File, OriginatorBusiness, PaginablePayloadApiResponse, PayloadApiResponse } from '@portal-workspace/grow-shared-library';
import { DeadletteredSalesforceJob, GetDeadletteredSalesforceJobsFn, RequeueDeadletteredSalesforceJobFn, SalesforceSyncRecordType } from '@portal-workspace/grow-shared-library';
import {
  KybEntitySummaryFn,
  KybEntitySummaryResult,
  KybInitiateCorporatePartyFn,
  KybInitiateCorporatePartyInput,
  KybInitiateCorporatePartyResult,
  KybResult,
  KybRefreshFn,
  KybResultFn,
  KybSetManualModeFn,
  TrustAnalysis,
  TrustAnalysisSummaryFn,
  TrustAnalysisSummaryResult,
  UploadTrustDeedFn,
  UploadTrustDeedInput,
  RequiredTrustDeed,
  RequiredTrustDeedsFn,
} from '@portal-workspace/grow-shared-library';
import { combineLatest, Observable, Observer, of, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  BusinessNumberSearchFn,
  AggregatorSearchFn,
  PortalHotToastService, ApplicationDialogService,
  toPaginationInfo,
  paginationUrl,
  SearchableSelectItem
} from '@portal-workspace/grow-ui-library';
import { AggregatorSearchComponentValue, } from '@portal-workspace/grow-shared-library';
import { DEFAULT_FILTER, DEFAULT_LIMIT, DEFAULT_OFFSET, DEFAULT_SORTS } from '@portal-workspace/grow-shared-library';
import moment from 'moment'
import {
  httpOptions,
} from '@portal-workspace/grow-ui-library';
import { BusinessSearchFn } from '@portal-workspace/grow-ui-library';
import {
  navigationUrlForAssetProductSelector, navigationUrlForBusinessFinance, navigationUrlForBusinessOverdraft,
  navigationUrlForInsurancePremium,
} from './navigation-urls';
import { Router } from '@angular/router';
import { Response } from 'request';

const URL_GET_APPLICATIONS = () => `${environment.api2Host}/api2/applications-list-by-user2`;

const URL_GET_APPLICATION = () => `${environment.api2Host}/api2/fetch-application`;
const URL_SEARCH_COMPANY_BY_NAME = (name: string) => `${environment.api2Host}/api2/search-company-by-name/${name}`;
const URL_SEARCH_BROKER_BY_NAME2 = (name: string) => `${environment.api2Host}/api2/originator_business/getOriginators2/${name}`;
const URL_GET_RATECARD_DETAILS = (userId: number, type: ApplicationTypes) => `${environment.api2Host}/api2/company-rate-card/${userId}/${type}`;
const URL_GET_DEFAULT_RATECARD_DETAILS = (type: ApplicationTypes) => `${environment.api2Host}/api2/default-rate-card/${type}`;
const URL_GET_IP_ADDRESS = () => `https://api.ipify.org/?format=json`;
const URL_GET_BROKER_FOR_USER = (userId: number) => `${environment.api2Host}/api2/getApplicationBrokerbyUserid/${userId}`;

const URL_SAVE_APPLICATION = () => `${environment.api2Host}/api2/store-application`; // post
const URL_UPDATE_APPLICATION = () => `${environment.api2Host}/api2/update-application2`; // put
const URL_UPDATE_APPLICATION_SF = () => `${environment.api2Host}/api2/update-application-sf`; // put
const URL_UPDATE_APPLICATION_ANZSIC = () => `${environment.api2Host}/api2/update-application-anzsic`; // put
const URL_UPDATE_APPLICATION_BORROWER_PROPERTY_OWNER = () => `${environment.api2Host}/api2/update-application-borrower-property-owner`; // put
const URL_UPDATE_LOAN_PURPOSE = () => `${environment.api2Host}/api2/update-loan-purpose`; // put
const URL_SUBMIT_APPLICATION = () => `${environment.api2Host}/api2/submit-to-inteflow2`; // post  (asset, business-loan)
const URL_SUBMIT_INSURANCE_PREMIUM_APPLICATION = () => `${environment.api2Host}/api2/IPF2`; // post
const URL_UPDATE_APPLICATION_SUBMITTER = () => `${environment.api2Host}/api2/update-application-submitter`; // posts
const URL_UPDATE_APPLICATION_ADDITIONAL_CORRESPONDENT = () => `${environment.api2Host}/api2/update-application-additional-correspondent`; // post
const URL_UPDATE_APPLICATION_BROKER = () => `${environment.api2Host}/api2/update-application-broker`; // post
const URL_UPDATE_APPLICATION_SALES_CONTACT = () => `${environment.api2Host}/api2/update-application-sales-contact`; // post
const URL_UPDATE_APPLICATION_CREDIT_OFFICER = () => `${environment.api2Host}/api2/update-application-credit-officer`; // post
const URL_SAVE_QUOTE = () => `${environment.api2Host}/api2/save-quote`; // post

const URL_UPDATE_APPLICATION_DOCUMENT_TO_AZURE_STORAGE = (applicationId: number) => `${environment.api2Host}/api2/document/update-application-document-to-azure-storage/${applicationId}`; // post
const URL_LIST_APPLICATION_DOCUMENT_FROM_AZURE_STORAGE = (applicationId: number) => `${environment.api2Host}/api2/document/list-application-document-from-azure-storage/${applicationId}`; // get
const URL_DOWNLOAD_APPLICATION_DOCUMENT_FROM_AZURE_STORAGE = (applicationId: number) => `${environment.api2Host}/api2/document/download-application-document-from-azure-storage/${applicationId}`; // get
const URL_DOWNLOAD_ALL_APPLICATION_DOCUMENT_FROM_AZURE_STORAGE = (applicationId: number, customerName: string, userId: number) => `${environment.api2Host}/api2/document/download-all-application-document-from-azure-storage/${applicationId}/${customerName}/${userId}`; // get
const URL_UPDATE_DOCUMENT_METADATA_IN_AZURE_STORAGE = () => `${environment.api2Host}/api2/document/update-document-metadata-in-azure-storage`; // post
const URL_UPDATE_DOCUMENT_TAGS_IN_AZURE_STORAGE = () => `${environment.api2Host}/api2/document/update-document-tags-in-azure-storage`; // post
const URL_DELETE_DOCUMENT_FROM_AZURE_STORAGE = () => `${environment.api2Host}/api2/document/delete-document-from-azure-storage`; // post
const URL_UPDATE_APPLICATION_DOCUMENT_IN_DB = () => `${environment.api2Host}/api2/document/update-application-documents-in-db`; // post
const URL_GET_DOCUMENT_WORKLIST = () => `${environment.api2Host}/api2/get-document-worklist`; // get
const URL_UPDATE_DOCUMENT_WORKLIST = () => `${environment.api2Host}/api2/update-document-worklist`; // post
const URL_CREATE_DOCUMENT_WORKLIST = () => `${environment.api2Host}/api2/create-document-worklist`; // post
const URL_COMPLETE_DOCUMENT_WORKLIST = (applicationId: number) => `${environment.api2Host}/api2/complete-document-worklist/${applicationId}`; // post

const URL_GET_ORIGINATOR_BUSINESS_BY_ID = (originatorBusinessId: number) => `${environment.api2Host}/api2/originator_business/${originatorBusinessId}`;
const URL_GET_APPLICATION_MONTHWISE_STATISTICS = () => `${environment.api2Host}/api2/get-approved-monthwise`;
const URL_GET_APPLICATION_STATISTICS = () => `${environment.api2Host}/api2/get-application-stats`;
const URL_GET_INPROGRESS_APPLICATION_STATISTICS = () => `${environment.api2Host}/api2/get-inprogress`;
const URL_GET_OVERDRAFT_PRODUCT_TOTAL_BALANCE_STATISTICS = () => `${environment.api2Host}/api2/get-overdraft-product-total-balance`;
const URL_GET_SETTLED_APPLICATION_STATISTICS = () => `${environment.api2Host}/api2/get-settled-application-stats`;
const URL_GET_NEWS = () => `${environment.api2Host}/api2/getNews`;
const URL_GET_BANKSTATEMENTS_ANALYSIS = () => `${environment.api2Host}/api2/bankstatement/analysis`;
const URL_GET_BANK_STATEMENT_AND_BASIQ_DATA_STATUS = (reference: string, type: BasiqReferenceType) => `${environment.api2Host}/api2/get-bank-statement-and-basiq-data-status/${reference}/${type}`;
const URL_GET_BASIQ_CUSTOMER_MAPPING_BY_ABN = (reference: string) => `${environment.api2Host}/api2/basiq-customer-mapping-by-reference/${reference}`;
const URL_GET_BASIQ_STATEMENT_DATA_FOR_COMPANY = () => `${environment.api2Host}/api2/basiq-statement-data-for-company`;
const URL_CHECK_ACTIVE_OVERDRAFT_ACCOUNT = () => `${environment.api2Host}/api2/check-active-overdraft-account`;

const URL_SERVICEABILITY_CALCULATION = () => `${environment.api2Host}/api2/serviceability-calculation`; // post
const URL_CREATE_NEW_DISBURSEMENT = () => `${environment.api2Host}/api2/create-new-disbursement`;
const URL_UPDATE_DISBURSEMENT = () => `${environment.api2Host}/api2/update-disbursement`;
const URL_GET_DISBURSEMENT_BY_APPLICATION_ID = (applicationId: number) => `${environment.api2Host}/api2/get-disbursement-by-application/${applicationId}`;
const URL_SYNC_DISBURSEMENT_TO_SF = () => `${environment.api2Host}/api2/sync-disbursement-to-sf`;
const URL_SYNC_BANK_DETAILS_TO_SF = () => `${environment.api2Host}/api2/sync-bank-details-to-sf`;
const URL_SYNC_PRIVATE_SELLER_BANK_DETAILS_TO_SF = () => `${environment.api2Host}/api2/sync-private-seller-bank-details-to-sf`;
const URL_BUSINESS_NUMBER_SEARCH = (acn: string) => `${environment.api2Host}/api2/business-number-search/${acn}`;  // get
const URL_GET_KYB_RESULT = (applicationId: number) => `${environment.api2Host}/api2/get-kyb-result/${applicationId}`; // get
const URL_GET_APPLICATION_KYB_SUMMARY = (applicationId: number) => `${environment.api2Host}/api2/get-application-kyb-summary/${applicationId}`; // get
const URL_DOWNLOAD_APPLICATION_KYB_REPORT = (applicationId: number, commercialEntityId: number) =>
  `${environment.api2Host}/api2/download-application-kyb-report/${applicationId}/${commercialEntityId}`; // get
const URL_RUN_APPLICATION_KYB_WORKFLOW = () => `${environment.api2Host}/api2/run-application-kyb-workflow`; // post
const URL_REFRESH_FRANKIEONE_KYB = () => `${environment.api2Host}/api2/refresh-frankieone-kyb`; // post
const URL_GET_TRUST_ANALYSIS_SUMMARY = (applicationId: number) => `${environment.api2Host}/api2/get-trust-analysis-summary/${applicationId}`; // get
const URL_UPLOAD_TRUST_DEED = () => `${environment.api2Host}/api2/upload-trust-deed`; // post
const URL_SYNC_REQUIRED_TRUST_DEEDS = () => `${environment.api2Host}/api2/sync-required-trust-deeds`; // post
const URL_RETRY_TRUST_ANALYSIS = () => `${environment.api2Host}/api2/retry-trust-analysis`; // post
const URL_GET_APPLICATION_KYB_RUNS = (paginationInfo: PaginationInfo, filters: ApplicationKybRunFilters) => {
  const url = paginationUrl(`${environment.api2Host}/api2/application-kyb-runs`, paginationInfo);
  const params = new URLSearchParams();
  if (filters.queueView) params.set('queueView', filters.queueView);
  if (filters.applicationState) params.set('applicationState', filters.applicationState);
  if (filters.attentionReasons?.length) {
    params.set('attentionReasons', filters.attentionReasons.join(','));
  }
  if (filters.statuses?.length) params.set('statuses', filters.statuses.join(','));
  if (filters.reconciliationStatuses?.length) {
    params.set('reconciliationStatuses', filters.reconciliationStatuses.join(','));
  }
  if (filters.search) params.set('search', filters.search);
  if (filters.startDate) params.set('startDate', filters.startDate);
  if (filters.endDate) params.set('endDate', filters.endDate);
  const query = params.toString();
  return query ? `${url}&${query}` : url;
}; // get
const URL_RETRY_APPLICATION_KYB_RUNS = () => `${environment.api2Host}/api2/retry-application-kyb-runs`; // post
const URL_RETRY_KYB_REEVALUATION = () => `${environment.api2Host}/api2/retry-kyb-reevaluation`; // post
const amlDashboardFilterParams = (filters: AmlDashboardFilters): string => {
  const params = new URLSearchParams();
  if (filters.officers?.length) params.set('officers', filters.officers.join(','));
  if (filters.checks) params.set('checks', filters.checks);
  if (filters.stages?.length) params.set('stages', filters.stages.join(','));
  if (filters.privacy?.length) params.set('privacy', filters.privacy.join(','));
  if (filters.kyc?.length) params.set('kyc', filters.kyc.join(','));
  if (filters.kyb?.length) params.set('kyb', filters.kyb.join(','));
  if (filters.risks?.length) params.set('risks', filters.risks.join(','));
  if (filters.search) params.set('search', filters.search);
  if (filters.startDate) params.set('startDate', filters.startDate);
  if (filters.endDate) params.set('endDate', filters.endDate);
  return params.toString();
};
const URL_GET_AML_DASHBOARD = (paginationInfo: PaginationInfo, filters: AmlDashboardFilters) => {
  const url = paginationUrl(`${environment.api2Host}/api2/aml-dashboard`, paginationInfo);
  const query = amlDashboardFilterParams(filters);
  return query ? `${url}&${query}` : url;
}; // get
const URL_DOWNLOAD_AML_DASHBOARD_CSV = (filters: AmlDashboardFilters, sort: AmlDashboardSort | null) => {
  const params = new URLSearchParams(amlDashboardFilterParams(filters));
  // Same `sorts` format the pagination helper sends for the dashboard page.
  if (sort) params.set('sorts', sort.dir === 'asc' ? sort.prop : `-${sort.prop}`);
  const query = params.toString();
  return `${environment.api2Host}/api2/aml-dashboard/download-csv${query ? `?${query}` : ''}`;
}; // get
const URL_GET_AML_OFFICER_CANDIDATES = () => `${environment.api2Host}/api2/get-aml-officer-candidates`; // get
const URL_UPDATE_AML_OFFICER_FOR_APPLICATION = () => `${environment.api2Host}/api2/update-aml-officer-for-application`; // post
const URL_GET_KYB_RISK_STATUS = () => `${environment.api2Host}/api2/get-kyb-risk-status`; // post
const URL_INITIATE_CORPORATE_PARTY_KYB = () => `${environment.api2Host}/api2/initiate-corporate-party-kyb`; // post
const URL_SET_MANUAL_KYB_MODE = () => `${environment.api2Host}/api2/set-manual-kyb-mode`; // post
const URL_MERGE_APPLICATION_INDIVIDUALS = () => `${environment.api2Host}/api2/merge-application-individuals`; // post
const URL_ADD_APPLICATION_PARTY = () => `${environment.api2Host}/api2/add-application-party`; // post
const URL_GET_BPAY_BILLER_NAME_BY_BILLERCODE = (billerCode: string) => `${environment.api2Host}/api2/bpay/get-biller/${billerCode}`; //get
const URL_VALIDATE_BPAY = () => `${environment.api2Host}/api2/bpay/validate-payment`;
const URL_UPDATE_APPLICATION_STAGE_IN_SF = () => `${environment.api2Host}/api2/update-application-stage-in-sf`; // post
const URL_SETTLE_LOAN = () => `${environment.api2Host}/api2/settle-loan`; // post
const URL_GET_INSTITUTION_NAME = (bsb: string) => `${environment.api2Host}/api2/institution-name/${bsb}`; //get
const URL_SYNC_DEPOSIT_PAID_TO_SF = () => `${environment.api2Host}/api2/sync-disbursement-deposit-paid-to-sf`; // post
const URL_GET_BANK_DETAILS_FROM_OPPORTUNITY_SF = (salesforceId: string) => `${environment.api2Host}/api2/get-bank-details-from-opportunity-sf/${salesforceId}`; //get
const URL_GENERATE_APPROVAL_NOTICE = () => `${environment.api2Host}/api2/generate-approval-notice`; // post
const URL_SEND_APPROVAL_NOTICE_EMAIL = () => `${environment.api2Host}/api2/send-approval-notice-email`; // post
const URL_SEND_DOCUMENT_REVIEW_EMAIL = () => `${environment.api2Host}/api2/send-document-review-email`; // post
const URL_DELETE_APPROVAL_NOTICE_FILE = () => `${environment.api2Host}/api2/delete-approval-notice-file`; // post
const URL_EXTRACT_TAX_INVOICE = () => `${environment.api2Host}/api2/extract-tax-invoice`; // post
const URL_GET_LVR_CALCULATOR_VALUE = (applicationId: number) => `${environment.api2Host}/api2/application/${applicationId}/lvr`; // get
const URL_UPDATE_LVR_CALCULATOR_VALUE = (applicationId: number): string => `${environment.api2Host}/api2/application/${applicationId}/lvr/save`; // post
const URL_GET_DSCR_CALCULATOR_VALUE = (applicationId: number) => `${environment.api2Host}/api2/application/${applicationId}/dscr`; // get
const URL_UPDATE_DSCR_CALCULATOR_VALUE = (applicationId: number): string => `${environment.api2Host}/api2/application/${applicationId}/dscr/save`; // post
const URL_DOWNLOAD_VERIMOTO_REPORT = (encodedInspectionId: number) => `${environment.api2Host}/api2/download-verimoto-report/${encodedInspectionId}`; // get
const URL_DOWNLOAD_DOCUMENT_FROM_AZURE = () => `${environment.api2Host}/api2/download-document-from-azure`;
const URL_GET_BSA_LENDER_LIST = () => `${environment.api2Host}/api2/bsa-lender-list`;
const URL_GET_BSA_EXCLUDED_LENDER_LIST = () => `${environment.api2Host}/api2/bsa-excluded-lender-list`;
const URL_UPDATE_BSA_EXCLUDED_LENDER = () => `${environment.api2Host}/api2/bsa-update-excluded-lender`;
const URL_UPDATE_BSA_LENDER = () => `${environment.api2Host}/api2/bsa-update-lender`;
const URL_DELETE_BSA_LENDER = (id: number) => `${environment.api2Host}/api2/bsa-delete-lender/${id}`;
const URL_DELETE_BSA_EXCLUDED_LENDER = (id: number) => `${environment.api2Host}/api2/bsa-delete-excluded-lender/${id}`
const URL_ADD_BSA_LENDER = () => `${environment.api2Host}/api2/bsa-add-lender`;
const URL_ADD_BSA_EXCLUDED_LENDER = () => `${environment.api2Host}/api2/bsa-add-excluded-lender`;
const URL_BSA_GET_CALCULATOR = (applicationId: number) => `${environment.api2Host}/api2/bsa-calculator/${applicationId}`;
const URL_BSA_SAVE_CALCULATOR = () => `${environment.api2Host}/api2/bsa-calculator`;
const URL_ADD_CREDIT_FLOW = () => `${environment.api2Host}/api2/credit/add-credit-flow`;
const URL_GET_CREDIT_FLOWS = () => `${environment.api2Host}/api2/credit/get-credit-flows`;
const URL_UPDATE_CREDIT_FLOW = (id: number) => `${environment.api2Host}/api2/credit/update-credit-flow/${id}`;
const URL_ADD_CREDIT_FLOW_NODE = () => `${environment.api2Host}/api2/credit/add-credit-flow-node`;
const URL_ADD_CREDIT_RULE_MAPPING = () => `${environment.api2Host}/api2/credit/add-credit-rule-mapping`;
const URL_GET_CREDIT_FLOW_BY_ID = (flowId: number) => `${environment.api2Host}/api2/credit/get-credit-flow/${flowId}`;
const URL_UPDATE_CREDIT_FLOW_NODE = (nodeId: number) => `${environment.api2Host}/api2/credit/update-credit-flow-node/${nodeId}`;
const URL_UPDATE_CREDIT_RULE_MAPPING = (mappingId: number) => `${environment.api2Host}/api2/credit/update-credit-rule-mapping/${mappingId}`;
const URL_RUN_CREDIT_FLOW = (applicationId: number, startFromLastRun: boolean) =>
  `${environment.api2Host}/api2/credit/run-credit-flow/${applicationId}/${startFromLastRun}`;
const URL_UPDATE_APPLICATION_PRODUCT_TYPE = () => `${environment.api2Host}/api2/credit/update-application-product-type`;
const URL_CHECK_CREDIT_FLOW_CONSENT_BLOCK = (applicationId: number) => `${environment.api2Host}/api2/credit/check-consent-block/${applicationId}`;
const URL_CREDIT_APPROVAL_READINESS = (applicationId: number) => `${environment.api2Host}/api2/credit/approval-readiness/${applicationId}`;
const URL_GET_CREDIT_ALERTS = () => `${environment.api2Host}/api2/credit/get-credit-alerts`;
const URL_UDPATE_CREDIT_ALERT = (alertId: number)=> `${environment.api2Host}/api2/credit/update-credit-alert/${alertId}`;
const URL_ADD_CREDIT_ALERT = () => `${environment.api2Host}/api2/credit/add-credit-alert`;
const URL_GET_CREDIT_ALERT_BY_STATUS = (status: CreditAlertStatus) => `${environment.api2Host}/api2/credit/get-credit-alert-by-status/${status}`;
const URL_COPY_CREDIT_FLOW = () => `${environment.api2Host}/api2/credit/copy-credit-flow`;
const URL_BSA_GET_DSCR_CALCULATOR_HISTORY = (applicationId: number) => `${environment.api2Host}/api2/dscr-calculator-history/${applicationId}`;
const URL_GET_CREDIT_RULE_ITEMS = () => `${environment.api2Host}/api2/credit/get-credit-rule-items`;
const URL_UDPATE_CREDIT_RULE_ITEM = (itemId: number)=> `${environment.api2Host}/api2/credit/update-credit-rule-item/${itemId}`;
const URL_ADD_CREDIT_RULE_ITEM = () => `${environment.api2Host}/api2/credit/add-credit-rule-item`;
const URL_PUBLISH_CREDIT_FLOW = (flowId: number)=> `${environment.api2Host}/api2/credit/publish-credit-flow/${flowId}`;
const URL_GET_COMMERCIAL_ENTITIES_INDIVIDUALS_WEB_SERVICES = (applicationId: number,isSeeMore: boolean = false) => `${environment.api2Host}/api2/credit/get-web-services/${applicationId}?isSeeMore=${isSeeMore}`;
const URL_GET_APPLICATION_CREDIT_FLOW_RESULT = (applicationId: number) => `${environment.api2Host}/api2/credit/get-application-credit-flow-result/${applicationId}`;
const URL_GET_HISTORICAL_CONTRACTS = (applicationId: number) => `${environment.api2Host}/api2/credit/get-historical-contracts/${applicationId}`;
const URL_GET_PISMO_CONTRACTS = (applicationId: number) => `${environment.api2Host}/api2/credit/get-pismo-contracts/${applicationId}`;
const URL_DOWNLOAD_CREDITORWATCH_REPORT = (pdfId: number) => `${environment.api2Host}/api2/credit/download-creditorwatch-report/${pdfId}`; // get
const URL_UPDATE_CREDIT_STATUS = () => `${environment.api2Host}/api2/credit/update-credit-status`;
const URL_GET_CREDIT_AUDIT_LOG = (applicationId: number, paginationInfo : PaginationInfo) => paginationUrl(`${environment.api2Host}/api2/credit/get-credit-alerts/${applicationId}`, paginationInfo);
const URL_GET_WEB_SERVICE_REPORT = (webServiceId: number) => `${environment.api2Host}/api2/credit/get-web-service-report/${webServiceId}`;
const URL_GET_DUPLCIATED_APPLICATIONS = (applicationId: number) => `${environment.api2Host}/api2/credit/get-duplicated-applications/${applicationId}`;
const URL_DELETE_WEB_SERVICES = () => `${environment.api2Host}/api2/credit/delete-web-services`;
const URL_UPDATE_CREDIT_OFFICER = () => `${environment.api2Host}/api2/credit/update-credit-officer`;
const URL_GET_APPLICATION_SETTLEMENTS_OFFICER = () => `${environment.api2Host}/api2/get-application-settlements-officer`; //get
const URL_UPDATE_SETTLEMENTS_OFFICER_FOR_APPLICATION = () => `${environment.api2Host}/api2/update-settlements-officer-for-application`;
const URL_UPDATE_CONNECTION_TO_OTHER_CREDIT_FLOW = () => `${environment.api2Host}/api2/credit/update-connection-to-other-credit-flow`;
const URL_CLEAR_CONNECTION_TO_OTHER_CREDIT_FLOW = () => `${environment.api2Host}/api2/credit/clear-connection-to-other-credit-flow`;

const URL_FETCH_RBA_RATES = () => `${environment.api2Host}/api2/getLatestRbaRate`; //get
const URL_GET_APPLICATION_OWNER = (salesforceId: string) => `${environment.api2Host}/api2/get-application-owner/${salesforceId}`; //get
const URL_GET_APPLICATION_BY_SALESFORCE_ID = (salesforceId: string) => `${environment.api2Host}/api2/get-application-by-salesforce-id/${salesforceId}`; //get
const URL_REFRESH_BANK_STATEMENT = (abn: string) => `${environment.api2Host}/api2/refresh-bank-statement/${abn}`; //get
const URL_GET_ACCOUNT_DETAILS_FROM_SF = (salesforceId: string) => `${environment.api2Host}/api2/get-account-details-from-sf/${salesforceId}`; // get
const URL_DELETE_APPLICATION = (applicationId: number) => `${environment.api2Host}/api2/application/delete/${applicationId}`; //delete
const URL_ALL_APPLICATION_SEARCH = (paginationInfo: PaginationInfo) => paginationUrl(`${environment.api2Host}/api2/search-applications`, paginationInfo); //post
const URL_CREATE_ASSET_INSPECTION = () => `${environment.api2Host}/api2/create-asset-inspection`; //post
const URL_GET_ASSET_INSPECTIONS_FOR_APPLICATION = (applicationId: number) => `${environment.api2Host}/api2/asset-inspections/${applicationId}`; //get
const URL_GET_ACTIVE_CREDIT_USERS = () => `${environment.api2Host}/api2/get-all-active-credit-users`; //get
const URL_UPLOAD_BANK_STATEMENTS = (applicationId: number) => `${environment.api2Host}/api2/document/upload-bank-statements/${applicationId}`;
const URL_CREDIT_MORE_INFORMATION = () => `${environment.api2Host}/api2/credit/request-more-information`;
const URL_WITHDRAW_APPLICATION = () => `${environment.api2Host}/api2/withdraw-application`;
const URL_GET_APPLICATION_CREDIT_OFFICER = (salesforceId: string) => `${environment.api2Host}/api2/get-application-credit-officer/${salesforceId}`; //get
const URL_GET_APPLICATION_DSCR = (applicationId: number) => `${environment.api2Host}/api2/credit/get-dscr/${applicationId}`; //get
const URL_GET_APPLICATION_EXPOSURE = (applicationId: number) => `${environment.api2Host}/api2/credit/get-exposure/${applicationId}`; //get
const URL_RECALCULATE_EXPOSURE_AT_SUBMISSION = (applicationId: number) => `${environment.api2Host}/api2/credit/recalculate-exposure-at-submission/${applicationId}`; //post
const URL_GET_SATISFACTORY_CONDUCT = (applicationId: number) => `${environment.api2Host}/api2/credit/get-satisfactory-conduct/${applicationId}`; //get
const URL_TEST_CREDIT_RULE = () => `${environment.api2Host}/api2/credit/test-credit-rule`; // post
const URL_TEST_CREDIT_FLOW = () => `${environment.api2Host}/api2/credit/test-credit-flow`; // post
const URL_TEST_CREDIT_FLOW_NODE = () => `${environment.api2Host}/api2/credit/test-credit-flow-node`; // post
const URL_TEST_CREDIT_RULE_ITEM = () => `${environment.api2Host}/api2/credit/test-credit-rule-item`; // post
const URL_SET_APPLICATION_TO_DRAFT = (applicationId: number) => `${environment.api2Host}/api2/set-application-to-draft/${applicationId}`; // post
const URL_GET_DEADLETTERED_SALESFORCE_JOBS_FOR_RECORD = (recordType: SalesforceSyncRecordType, recordId: number) =>
  `${environment.api2Host}/api2/salesforce-outbox/deadlettered-jobs-for-record?recordType=${recordType}&recordId=${recordId}`; // get
const URL_REQUEUE_DEADLETTERED_SALESFORCE_JOB = () => `${environment.api2Host}/api2/salesforce-outbox/requeue-deadlettered-job`; // post

@Injectable()
export class ApplicationService {
  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private dialogService: ApplicationDialogService,
    private portalHotToastService: PortalHotToastService) {
  }


  async applicationTilesComponentNavigationHandler(applicationTypes: ApplicationTypes) {
    const applicationSubmissionConfig = environment.applicationSubmission;
    const openDisableSubmissionDialog = () => {
      this.dialogService.openInformationDialog({
        message: `Information`,
        subMessage: applicationSubmissionConfig.disabledMessage,
      });
    }
    switch (applicationTypes) {
      case 'AssetFinance':
        if (applicationSubmissionConfig.AssetFinance) {
          await this.router.navigate(navigationUrlForAssetProductSelector());
        } else {
          openDisableSubmissionDialog();
        }
        break;
      case 'BusinessLoans':
        if (applicationSubmissionConfig.BusinessLoans) {
          await this.router.navigate(navigationUrlForBusinessFinance());
        } else {
          openDisableSubmissionDialog();
        }
        break;
      case 'InsurancePremium':
        if (applicationSubmissionConfig.InsurancePremium) {
          await this.router.navigate(navigationUrlForInsurancePremium());
        } else {
          openDisableSubmissionDialog();
        }
        break;
      case 'BusinessOverdraft':
        if (applicationSubmissionConfig.BusinessOverdraft) {
          await this.router.navigate(navigationUrlForBusinessOverdraft());
        } else {
          openDisableSubmissionDialog();
        }
        break;
    }
  }

  businessNumberSearchFn: BusinessNumberSearchFn = (businessNumber: string): Observable<BusinessNumberSearchResult> => {
    return this.businessNumberSearch(businessNumber).pipe(map(r => r.payload));
  }

  kybResultFn: KybResultFn = (applicationId: number): Observable<KybResult> => {
    return this.getKybResult(applicationId).pipe(map(r => r.payload));
  }

  getKybResult(applicationId: number): Observable<PayloadApiResponse<KybResult>> {
    return this.httpClient.get<PayloadApiResponse<KybResult>>(URL_GET_KYB_RESULT(applicationId), httpOptions());
  }

  kybSetManualModeFn: KybSetManualModeFn = (
    applicationId: number,
    commercialEntityId?: number | null,
  ): Observable<KybResult> => this.httpClient.post<PayloadApiResponse<KybResult>>(
    URL_SET_MANUAL_KYB_MODE(),
    {applicationId, commercialEntityId: commercialEntityId ?? null},
    httpOptions(),
  ).pipe(
    map(response => response.payload),
    catchError(err => {
      this.portalHotToastService.warn(`Unable to enter manual company details`);
      return throwError(() => err);
    }),
  );

  kybEntitySummaryFn: KybEntitySummaryFn = (applicationId: number): Observable<KybEntitySummaryResult> => {
    return this.getApplicationKybSummary(applicationId).pipe(map(r => r.payload));
  }

  getApplicationKybSummary(applicationId: number): Observable<PayloadApiResponse<KybEntitySummaryResult>> {
    return this.httpClient.get<PayloadApiResponse<KybEntitySummaryResult>>(
      URL_GET_APPLICATION_KYB_SUMMARY(applicationId),
      httpOptions(),
    );
  }

  downloadApplicationKybReportFn = (applicationId: number, commercialEntityId: number): Observable<Blob> => {
    const options = { ...httpOptions(), observe: 'body' as const, responseType: 'blob' as 'json' };
    return this.httpClient.get<Blob>(
      URL_DOWNLOAD_APPLICATION_KYB_REPORT(applicationId, commercialEntityId),
      options,
    );
  }

  runApplicationKybWorkflowFn = (applicationId: number, commercialEntityId: number): Observable<ApiResponse> =>
    this.httpClient.post<ApiResponse>(
      URL_RUN_APPLICATION_KYB_WORKFLOW(),
      {applicationId, commercialEntityId},
      httpOptions(),
    );

  trustAnalysisSummaryFn: TrustAnalysisSummaryFn = (applicationId: number): Observable<TrustAnalysisSummaryResult> => {
    return this.getTrustAnalysisSummary(applicationId).pipe(map(r => r.payload));
  }

  getTrustAnalysisSummary(applicationId: number): Observable<PayloadApiResponse<TrustAnalysisSummaryResult>> {
    return this.httpClient.get<PayloadApiResponse<TrustAnalysisSummaryResult>>(
      URL_GET_TRUST_ANALYSIS_SUMMARY(applicationId),
      httpOptions(),
    );
  }

  /**
   * Upload a trust deed and start its analysis. Returns the run so the caller can show the pending
   * state immediately; the extracted structure arrives later, via the workflow callback.
   */
  uploadTrustDeedFn: UploadTrustDeedFn = (
    input: UploadTrustDeedInput,
  ): Observable<PayloadApiResponse<TrustAnalysis>> => {
    return this.httpClient.post<PayloadApiResponse<TrustAnalysis>>(
      URL_UPLOAD_TRUST_DEED(),
      {
        applicationId: input.applicationId,
        commercialEntityId: input.commercialEntityId,
        file: input.file,
        conditionValue: input.conditionValue,
      },
      httpOptions(),
    );
  }

  /**
   * The deeds an application requires, one per entity, for the wizard step and the Documents tab.
   * A POST because the backend also stores the conditions it derives.
   */
  requiredTrustDeedsFn: RequiredTrustDeedsFn = (applicationId: number): Observable<RequiredTrustDeed[]> => {
    return this.httpClient.post<PayloadApiResponse<RequiredTrustDeed[]>>(
      URL_SYNC_REQUIRED_TRUST_DEEDS(),
      { applicationId },
      httpOptions(),
    ).pipe(map(r => r.payload));
  }

  retryTrustAnalysisFn = (applicationId: number, runId: number): Observable<PayloadApiResponse<TrustAnalysis>> => {
    return this.httpClient.post<PayloadApiResponse<TrustAnalysis>>(
      URL_RETRY_TRUST_ANALYSIS(),
      { applicationId, runId },
      httpOptions(),
    );
  }

  /**
   * Backs the Retry on the KYB waiting panels. Unlike kybResultFn this has side effects: it pulls
   * the result from FrankieOne when the callback never arrived. It never starts a new run.
   * Deliberately no blocking spinner - the waiting component renders its own progress.
   */
  kybRefreshFn: KybRefreshFn = (
    applicationId: number,
    commercialEntityId?: number | null,
  ): Observable<KybResult> => {
    return this.refreshFrankieOneKyb(applicationId, commercialEntityId).pipe(
      map(r => r.payload),
      catchError(err => {
        this.portalHotToastService.warn(`Unable to refresh the company check`);
        return throwError(() => err);
      }),
    );
  }

  refreshFrankieOneKyb(
    applicationId: number,
    commercialEntityId?: number | null,
  ): Observable<PayloadApiResponse<KybResult>> {
    return this.httpClient.post<PayloadApiResponse<KybResult>>(
      URL_REFRESH_FRANKIEONE_KYB(), {applicationId, commercialEntityId: commercialEntityId ?? null}, httpOptions());
  }

  // Deliberately no blocking spinner: initiation fires while the user is still filling in the
  // partner/trustee form, and the entity's own section shows its pending state inline.
  kybInitiateCorporatePartyFn: KybInitiateCorporatePartyFn = (
    input: KybInitiateCorporatePartyInput,
  ): Observable<KybInitiateCorporatePartyResult> => {
    return this.initiateCorporatePartyKyb(input).pipe(
      map(r => r.payload),
      catchError(err => {
        this.portalHotToastService.warn(`Unable to start the company check for this party`);
        return throwError(() => err);
      }),
    );
  }

  initiateCorporatePartyKyb(
    input: KybInitiateCorporatePartyInput,
  ): Observable<PayloadApiResponse<KybInitiateCorporatePartyResult>> {
    return this.httpClient.post<PayloadApiResponse<KybInitiateCorporatePartyResult>>(
      URL_INITIATE_CORPORATE_PARTY_KYB(), {...input}, httpOptions());
  }

  /**
   * Internal-only post-submission add of a corporate party (trustee/partner/guarantor entity) from
   * the KYC/AML tab. Persists the entity and starts its KYB run; the stakeholders arrive via webhook.
   * Distinct from kybInitiateCorporatePartyFn, which the broker wizard calls mid-step.
   */
  addApplicationParty(
    input: KybInitiateCorporatePartyInput,
  ): Observable<PayloadApiResponse<KybInitiateCorporatePartyResult>> {
    return this.httpClient.post<PayloadApiResponse<KybInitiateCorporatePartyResult>>(
      URL_ADD_APPLICATION_PARTY(), {...input}, httpOptions());
  }

  mergeApplicationIndividuals(input: MergeApplicationIndividualsInput): Observable<MergeApplicationIndividualsResult> {
    return this.httpClient.post<PayloadApiResponse<MergeApplicationIndividualsResult>>(
      URL_MERGE_APPLICATION_INDIVIDUALS(), {...input}, httpOptions(),
    ).pipe(map(response => response.payload));
  }

  businessNumberSearch = (businessNumber: string): Observable<PayloadApiResponse<BusinessNumberSearchResult>> => {
    return this.httpClient.get<PayloadApiResponse<BusinessNumberSearchResult>>(URL_BUSINESS_NUMBER_SEARCH(businessNumber), httpOptions());
  }

  serviceabilityCalculationFn = (input: ServiceabilityCalculationInput) => {
    return this.doServiceabilityCalculation(input).pipe(map(r => r.payload));
  }

  doServiceabilityCalculation(input: ServiceabilityCalculationInput): Observable<PayloadApiResponse<ServiceabilityCalculationResult>> {
    return this.httpClient.post<PayloadApiResponse<ServiceabilityCalculationResult>>(URL_SERVICEABILITY_CALCULATION(), {
      ...input
    }, httpOptions()).pipe();
  }


  getOriginatorBusinessById(originatorBusinessId: number): Observable<PayloadApiResponse<OriginatorBusiness | null>> {
    return this.httpClient.get<PayloadApiResponse<OriginatorBusiness>>(URL_GET_ORIGINATOR_BUSINESS_BY_ID(originatorBusinessId), httpOptions()).pipe();
  }

  getOriginatorBusinessByIdFn = (originatorBusinessId: number): Observable<OriginatorBusiness | null> => {
    return this.getOriginatorBusinessById(originatorBusinessId).pipe(map(r => r.payload));
  }

  updateApplicationSubmitter(applicationId: number, submitterUserId: number, data: UserSelectionValue, brokerSalesforceId: string, appInfoSalesforceId: string | undefined): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_APPLICATION_SUBMITTER(), {
      applicationId, submitterUserId, data, brokerSalesforceId, appInfoSalesforceId,
    }, httpOptions()).pipe();
  }

  updateApplicationAdditionalCorrespondent(applicationId: number, data: UserSelectionValue): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_APPLICATION_ADDITIONAL_CORRESPONDENT(), {
      applicationId, data
    }, httpOptions()).pipe();
  }

  

  updateApplicationBroker(applicationId: number, data: UserSelectionValue, oppId: string | undefined): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_APPLICATION_BROKER(), {
      applicationId, data, oppId
    }, httpOptions()).pipe();
  }

  updateApplicationSalesContact(applicationId: number, salesContactUserId: number, data: UserSelectionValue, salesforceId: string): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_APPLICATION_SALES_CONTACT(), {
      applicationId, salesContactUserId, data, salesforceId
    }, httpOptions()).pipe();
  }

  submitInsurancePremium(ApplicationId: number, data: SaveApplicationData): Observable<PayloadApiResponse<SubmitApplicationResult>> {
    const submittedData = { ...data };
    // no stringify needed, the api only update AppInfo section
    (submittedData as any).ApplicationId = ApplicationId;
    return this.httpClient.post<PayloadApiResponse<SubmitApplicationResult>>(URL_SUBMIT_INSURANCE_PREMIUM_APPLICATION(), {
      ApplicationId,
      data: submittedData
    }, httpOptions()).pipe();
  }



  submitApplication(ApplicationId: number, data: SaveApplicationData): Observable<PayloadApiResponse<SubmitApplicationResult>> {
    const submittedData = { ...data };
    // no stringify needed, the api only update AppInfo section
    (submittedData as any).ApplicationId = ApplicationId;
    return this.httpClient.post<PayloadApiResponse<SubmitApplicationResult>>(URL_SUBMIT_APPLICATION(), {
      ApplicationId,
      data: submittedData,
    }, httpOptions()).pipe();
  }

  updateApplicationSf(ApplicationId: number, data: UpdateApplicationData): Observable<ApiResponse> {
    return this.httpClient.put<ApiResponse>(URL_UPDATE_APPLICATION_SF(), {
      ApplicationId,
      data: data,
    }, httpOptions()).pipe();
  }

  updateApplicationSfFn: UpdateApplicationSfFn = (applicationId: number, data: UpdateApplicationData) => {
    return this.updateApplicationSf(applicationId, data);
  }

  updateApplicationAnzsic(body: UpdateApplicationAnzsicBody): Observable<ApiResponse> {
    return this.httpClient.put<ApiResponse>(URL_UPDATE_APPLICATION_ANZSIC(), body, httpOptions()).pipe();
  }

  updateApplicationAnzsicFn: UpdateApplicationAnzsicFn = (body: UpdateApplicationAnzsicBody) => {
    return this.updateApplicationAnzsic(body);
  }

  updateApplicationBorrowerPropertyOwner(body: UpdateApplicationBorrowerPropertyOwnerBody): Observable<ApiResponse> {
    return this.httpClient.put<ApiResponse>(URL_UPDATE_APPLICATION_BORROWER_PROPERTY_OWNER(), body, httpOptions()).pipe();
  }

  updateApplicationBorrowerPropertyOwnerFn: UpdateApplicationBorrowerPropertyOwnerFn = (body: UpdateApplicationBorrowerPropertyOwnerBody) => {
    return this.updateApplicationBorrowerPropertyOwner(body);
  }

  updateLoanPurpose(body: UpdateLoanPurposeBody): Observable<ApiResponse> {
    return this.httpClient.put<ApiResponse>(URL_UPDATE_LOAN_PURPOSE(), body, httpOptions()).pipe();
  }

  updateLoanPurposeFn: UpdateLoanPurposeFn = (body: UpdateLoanPurposeBody) => {
    return this.updateLoanPurpose(body);
  }

  updateApplication(ApplicationId: number, data: UpdateApplicationData): Observable<ApiResponse> {
    return this.httpClient.put<ApiResponse>(URL_UPDATE_APPLICATION(), {
      ApplicationId,
      data: data,
    }, httpOptions()).pipe();
  }

  updateApplicationFn: UpdateApplicationFn = (ApplicationId: number, data: UpdateApplicationData) => {
    return this.updateApplication(ApplicationId, data);
  }

  saveApplication(data: SaveApplicationData): Observable<PayloadApiResponse<SaveApplicationResult>> {
    return this.httpClient.post<PayloadApiResponse<SaveApplicationResult>>(URL_SAVE_APPLICATION(), data, httpOptions()).pipe();
  }

  getBrokerOfUser(userId: number): Observable<PayloadApiResponse<BrokerOfUser | null>> {
    return this.httpClient.get<PayloadApiResponse<BrokerOfUser>>(URL_GET_BROKER_FOR_USER(userId), httpOptions()).pipe();
  }

  getIpAddress(): Observable<PayloadApiResponse<string>> {
    return this.httpClient.get<{ ip: string }>(URL_GET_IP_ADDRESS()).pipe(
      map(r => {
        return {
          status: true,
          message: '',
          payload: r.ip,
        }
      }),
      catchError(err => {
        console.log(`error getting ip address`, err);
        return of({
          status: true,
          message: '',
          payload: '',
        });
      })
    );
  }

  getGeoLocation(): Promise<GeoLocation> {
    const self = this;
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition((position: GeolocationPosition) => {
        (self as any).noLocationPermission = true;
        if (!position) {
          resolve({});
          console.log('can\'t get location from static method getGeoLocation');
        }
        return resolve({
          lat: String(position.coords.latitude),
          long: String(position.coords.longitude),
        });
      },
        function (error) {
          if (error.code === error.PERMISSION_DENIED) {
            reject(`Please allow location detection to go further`)
            alert(`Please allow location detection to go further`);
            (self as any).noLocationPermission = false;
          }
        });
    });
  }

  getRatecardDetails(userId: number, type: ApplicationTypes): Observable<PayloadApiResponse<RatecardDetails>> {
    return this.httpClient.get<PayloadApiResponse<RatecardDetails>>(URL_GET_RATECARD_DETAILS(userId, type), httpOptions()).pipe();
  }

  getRatecardDetailsFn = (userId: number, type: ApplicationTypes) => {
    return this.getRatecardDetails(userId, type).pipe(map(r => r.payload));
  }
  getDefaultRatecardDetails(type: ApplicationTypes): Observable<PayloadApiResponse<RatecardDetails>> {
    return this.httpClient.get<PayloadApiResponse<RatecardDetails>>(URL_GET_DEFAULT_RATECARD_DETAILS(type), httpOptions()).pipe();
  }


  // we will remove this after migrating to api2 cause, all these will be done in the api2 then
  // this is done in api2 through toRatecardDetails(...) in share lib

  getDefaultRatecardDetailsFn: GetRateCardDetailsFn = (ratecardId: number, type: ApplicationTypes) => {
    return this.getDefaultRatecardDetails(type).pipe(map(r => r.payload));
  }

  brokerSearchFn: AggregatorSearchFn = (term: string) => {
    return this.searchBroker2(term).pipe(map(r => r.payload));
  }
  searchBroker2(name: string): Observable<PayloadApiResponse<Exclude<AggregatorSearchComponentValue, null>[]>> {
    return this.httpClient.get<PayloadApiResponse<Exclude<AggregatorSearchComponentValue, null>[]>>(URL_SEARCH_BROKER_BY_NAME2(name), httpOptions());
  }

  businessSearchFn: BusinessSearchFn = (search: string) => {
    return this.searchCompanyByName(search).pipe(
      map(r => r.payload ?? { numberOfRecords: 0, records: [] }),
      catchError(err => {
        this.portalHotToastService.warn(`Unable to perform business search`);
        return of({ numberOfRecords: 0, records: [] });
      })
    );
  }

  searchCompanyByName(name: string): Observable<PayloadApiResponse<SearchCompanyResult | null>> {
    return this.httpClient.post<PayloadApiResponse<SearchCompanyResult | null>>(URL_SEARCH_COMPANY_BY_NAME(name), {}, httpOptions());
  }

  getAbrResultByAbn(abn: string): Observable<SearchCompanyByABNResult | null> {
    return this.searchCompanyByName(abn).pipe(
      map(r => r.payload as SearchCompanyByABNResult | null),
      catchError(() => of(null))
    );
  }

  fetchABRdataByABN(abn: string): Promise<FetchABRdataByABNResult> {
    return new Promise((resolve, reject) => {
      this.searchCompanyByName(abn)
        .toPromise()
        .then(res => {
          const r: SearchCompanyByABNResult | undefined = res?.payload as SearchCompanyByABNResult;
          resolve(this.mapOrgeData(r));
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  mapOrgeData(res: SearchCompanyByABNResult | undefined): FetchABRdataByABNResult {
    let report = res;
    let response: FetchABRdataByABNResult = {};
    if (report) {
      let acn = (report['ASICNumber'] != undefined && Number(report['ASICNumber']) > 0) ? String(report['ASICNumber']) : null;
      if (acn != null) {
        let charRequiredtoFill = 9 - acn.toString().length;
        if (charRequiredtoFill > 0) {
          acn = ('0').repeat(charRequiredtoFill) + acn;
        }
        response['acn'] = acn.toString();
      }
      if (report.ABN && Array.isArray(report.ABN)) {
        response['abn'] = report.ABN[0].identifierValue.toString();
      } else if (report.ABN) {
        response['abn'] = report.ABN.identifierValue.toString();
      }
      let abnAgeMonths = 0;
      if (report['entityStatus'] !== undefined) {
        let entityStatus;
        if (Array.isArray(report['entityStatus'])) {
          entityStatus = report['entityStatus'][0];
        } else {
          entityStatus = report['entityStatus'];
        }
        abnAgeMonths = moment().diff(entityStatus['effectiveFrom'], 'months');
        response['ABNAgeMonths'] = abnAgeMonths;
      }
      if (report['goodsAndServicesTax'] !== undefined) {
        let goodsAndServicesTax;
        if (Array.isArray(report['goodsAndServicesTax'])) {
          goodsAndServicesTax = report['goodsAndServicesTax'][0];
        } else {
          goodsAndServicesTax = report['goodsAndServicesTax'];
        }
        let months = moment().diff(goodsAndServicesTax['effectiveFrom'], 'months');
        let years = moment().diff(goodsAndServicesTax['effectiveFrom'], 'years');
        let yearsInBusiness = years + (months % 12 / 10);
        response.yearsInBusiness = yearsInBusiness;
        response['GSTAgeMonths'] = months;
      }
      if (report['entityType'] !== undefined) {
        let entityType = report['entityType'];
        if (entityType['entityTypeCode'] == 'IND') {
          response.organisationType = 'Sole Trader';
          let legalName;
          if (Array.isArray(report['legalName'])) {
            legalName = report['legalName'][0];
          } else {
            legalName = report['legalName'];
          }
          response['legalName'] = legalName['givenName'];
          response['legalName'] += legalName['otherGivenName'] != '' ? ' ' + legalName['otherGivenName'] : '';
          response['legalName'] += legalName['familyName'] != '' ? ' ' + legalName['familyName'] : '';
        } else {
          let entityTypeText = getOrgTypeByEntityText(entityType['entityDescription']);
          response.organisationType = entityTypeText;
        }
      } else {
        response.organisationType = 'Other';
      }
      let entityType: 'PTY' | 'TRST' | 'PTNR' | 'PTY' | 'SLTR' = 'PTY';
      let orgType = response.organisationType;
      if (orgType === 'Trust') {
        entityType = 'TRST';
      } else if (orgType === 'Partnership') {
        entityType = 'PTNR';
      } else if (orgType === 'Company') {
        entityType = 'PTY';
      } else if (orgType === 'Sole Trader') {
        entityType = 'SLTR';
      } else {
        entityType = 'PTY';
      }
      response.entityType = entityType;
    }
    return response;
  }


  getApplicationById(applicationId: number): Observable<PayloadApiResponse<Application>> {
    return this.httpClient.post<PayloadApiResponse<Application>>(URL_GET_APPLICATION(), {
      ApplicationId: applicationId
    }, httpOptions()).pipe();
  }

  getApplicationByIdFn = (applicationId: number): Observable<Application> => {
    return this.getApplicationById(applicationId).pipe(map(res => res.payload));
  }


  getApplicationsByUser(
    options: {
      page: { offset: number, limit: number },
      sorts?: ApplicationSortTypes,
      filter: string,
    } = { page: { offset: DEFAULT_OFFSET, limit: DEFAULT_LIMIT }, sorts: DEFAULT_SORTS, filter: DEFAULT_FILTER }): Observable<PaginablePayloadApiResponse<SimplifiedApplication>> {
    return this.httpClient.post<PaginablePayloadApiResponse<SimplifiedApplication>>(URL_GET_APPLICATIONS(), options, httpOptions()).pipe();
  }

  getApplicationStatus2 = getApplicationStatus2;

  getApplicationStage2 = getApplicationStage2;

  uploadApplicationDocumentToAzureStorage(applicationId: number, newFiles: Base64File[], deletedFileNames: string[] = []): Observable<ApiResponse> {
    const nf = newFiles.map(f => ({
      base64: f.base64,
      name: f.name.replace(/[^\t\x20-\x7e\x80-\xff]/, '_'),
      size: f.size,
      type: f.type,
      tags: f?.tags ?? [],
      metadata: f?.metadata ?? {}
    }));
    const rf = deletedFileNames.map(f => ({ name: f }));
    return this.httpClient.post<ApiResponse>(URL_UPDATE_APPLICATION_DOCUMENT_TO_AZURE_STORAGE(applicationId), {
      new: nf,
      remove: rf,
    }, httpOptions());
  }

  uploadApplicationDocumentToAzureStorageFn = async (applicationId: number, files: File[] | Base64File[], deleteFiles: string[], isBase64File: boolean = false) => {
    const base64Files = isBase64File ? files as Base64File[] : await filesToBase64Files(files);
    const r = this.uploadApplicationDocumentToAzureStorage(applicationId, base64Files, deleteFiles)
      .pipe(
        switchMap(r => {
          return this.getApplicationById(applicationId).pipe(map(r => r.payload));
        })
      );
    return r;
  }

  listApplicationDocument = (applicationId: number): Observable<PayloadApiResponse<AzureStorageDocument[]>> => {
    return this.httpClient.get<PayloadApiResponse<AzureStorageDocument[]>>(URL_LIST_APPLICATION_DOCUMENT_FROM_AZURE_STORAGE(applicationId), httpOptions());
  }

  listApplicationDocumentFn = (applicationId: number, includeDeletedFile = false): Observable<AzureStorageDocument[]> => {
    return this.listApplicationDocument(applicationId).pipe(
      map((r: PayloadApiResponse<AzureStorageDocument[]>) => r.payload),
      map((docs: AzureStorageDocument[]) => {
        if (!includeDeletedFile) {
          return docs.filter(doc => !(doc?.metadata?.['isdeleted']) || !(doc?.metadata?.['isdeleted'].toLowerCase() === 'true'));
        } else {
          return docs;
        }
      })
    );
  }

  downloadApplicationDocument = (path: string, fileName: string, applicationId: number): string => {
    const urlWithParams = new URL(URL_DOWNLOAD_APPLICATION_DOCUMENT_FROM_AZURE_STORAGE(applicationId));
    urlWithParams.searchParams.append("path", path);
    urlWithParams.searchParams.append("fileName", fileName);

    return urlWithParams.href;
  }

  downloadApplicationDocumentUrlFn = (path: string, fileName: string, applicationId: number): Observable<Blob> => {
    const options = { ...httpOptions(), observe: 'body' as const, responseType: 'blob' as 'json' }
    return this.httpClient.get<Blob>(this.downloadApplicationDocument(path, fileName, applicationId), options)
  }

  downloadAllApplicationDocument = (applicationId: number, customerName: string, userId: number) => {
    return URL_DOWNLOAD_ALL_APPLICATION_DOCUMENT_FROM_AZURE_STORAGE(applicationId, customerName, userId);
  }

  downloadAllApplicationDocumentUrlFn = (applicationId: number, customerName: string, userId: number): Observable<Blob> => {
    const options = { ...httpOptions(), observe: 'body' as const, responseType: 'blob' as 'json' }
    return this.httpClient.get<Blob>(this.downloadAllApplicationDocument(applicationId, customerName, userId), options)
  }

  updateDocumentMetadata = (path: string, fileName: string, metadata: Metadata): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_DOCUMENT_METADATA_IN_AZURE_STORAGE(), { path: path, fileName: fileName, metadata: metadata }, httpOptions());
  }

  updateDocumentMetadataFn = (path: string, fileName: string, metadata: Metadata): Observable<ApiResponse> => {
    return this.updateDocumentMetadata(path, fileName, metadata);
  }

  approveApplicationDocumentFn = (path: string, fileName: string, tagName: string, userId: number | undefined): Observable<ApiResponse> => {
    return this.updateDocumentMetadataFn(path, fileName, { [tagName]: 'Accepted', statuschangedby: String(userId) });
  }

  declineApplicationDocumentFn = (path: string, fileName: string, tagName: string, userId: number | undefined): Observable<ApiResponse> => {
    return this.updateDocumentMetadataFn(path, fileName, { [tagName]: 'Rejected', statuschangedby: String(userId) });
  }

  undoApplicationDocumentFn = (path: string, fileName: string, tagName: string, userId: number | undefined): Observable<ApiResponse> => {
    return this.updateDocumentMetadataFn(path, fileName, { [tagName]: 'In Progress', statuschangedby: String(userId) });
  }

  updateCompanyDetailsForDocumentFn = (path: string, fileName: string, legalName: string, abn: string): Observable<ApiResponse> => {
    return this.updateDocumentMetadataFn(path, fileName, { legalname: legalName, abn: abn });
  }

  deleteApplicationDocument = (path: string, fileName: string, tagName: string): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_DELETE_DOCUMENT_FROM_AZURE_STORAGE(), { path: path, fileName: fileName, tag: tagName }, httpOptions());
  }

  deleteApplicationDocumentFn = (path: string, fileName: string, tagName: string): Observable<ApiResponse> => {
    return this.deleteApplicationDocument(path, fileName, tagName);
  }

  updateDocumentTags = (path: string, fileName: string, tags: string[]): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_DOCUMENT_TAGS_IN_AZURE_STORAGE(), { path: path, fileName: fileName, tags: tags }, httpOptions());
  }

  updateDocumentTagsFn = (path: string, fileName: string, tags: string[]): Observable<ApiResponse> => {
    return this.updateDocumentTags(path, fileName, tags);
  }

  updateApplicationRequiredDocuments = (applicationId: number, data: DocumentTag[]): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_APPLICATION_DOCUMENT_IN_DB(), { applicationId: applicationId, documents: data }, httpOptions());
  }

  updateApplicationRequiredDocumentsFn = (applicationId: number, data: DocumentTag[]): Observable<Application> => {
    return this.updateApplicationRequiredDocuments(applicationId, data).pipe(
      switchMap(r => {
        return this.getApplicationById(applicationId).pipe(map(r => r.payload));
      })
    );
  }
 
 

  saveQuote(data: Quote): Observable<PayloadApiResponse<SaveQuoteResult>> {
    return this.httpClient.post<PayloadApiResponse<SaveQuoteResult>>(URL_SAVE_QUOTE(), data, httpOptions()).pipe();
  }


  // NOTE: use share library's toApplication(...) in utils.ts
  // we will remove this after migrating to api2 cause, all these will be done in the api2 then

  getApplicationMonthWiseStatistics(params: {
    userId: number,
    role: string,
    // aggregatorId: number,
    OriginatorBusinessId: number
  }): Observable<PayloadApiResponse<ApplicationMonthlyStatistics>> {
    return this.httpClient.post<PayloadApiResponse<ApplicationMonthlyStatistics>>(URL_GET_APPLICATION_MONTHWISE_STATISTICS(), params, httpOptions()).pipe();
  }

  getApplicationStatistics(params: {
    userId: number,
    role: string,
    status: string,
    // aggregatorId: number,
    OriginatorBusinessId: number
  }): Observable<PayloadApiResponse<ApplicationStatistics>> {
    return this.httpClient.post<PayloadApiResponse<ApplicationStatistics>>(URL_GET_APPLICATION_STATISTICS(), params, httpOptions()).pipe();
  }

  getInProgressApplicationStatistics(params: {
    userId: number,
    role: string,
    status: string,
    // aggregatorId: number,
    OriginatorBusinessId: number
  }): Observable<PayloadApiResponse<InProgressApplicationStatistics>> {
    return this.httpClient.post<PayloadApiResponse<InProgressApplicationStatistics>>(URL_GET_INPROGRESS_APPLICATION_STATISTICS(), params, httpOptions()).pipe();
  }

  getOverdraftProductTotalBalanceStatistics(): Observable<PayloadApiResponse<OverdraftProductApplicationStatistics>> {
    return this.httpClient.get<PayloadApiResponse<OverdraftProductApplicationStatistics>>(URL_GET_OVERDRAFT_PRODUCT_TOTAL_BALANCE_STATISTICS(), httpOptions()).pipe();

  }

  getSettledApplicationStatistics(params: {
    userId: number,
    role: string,
    status: string,
    // aggregatorId: number,
    OriginatorBusinessId: number
  }): Observable<PayloadApiResponse<SettledApplicationStatistics>> {
    return this.httpClient.post<PayloadApiResponse<SettledApplicationStatistics>>(URL_GET_SETTLED_APPLICATION_STATISTICS(), params, httpOptions()).pipe();
  }

  getNews(): Observable<PayloadApiResponse<GetNewsResult>> {
    return this.httpClient.get<PayloadApiResponse<GetNewsResult>>(URL_GET_NEWS(), httpOptions()).pipe();
  }

  getBankStatementsAnalysisFn: GetBankStatementsAnalysisFn = (params: {
    reference: string, // abn
    includeHistory?: boolean
  }) => {
    return this.getBankStatementsAnalysis(params).pipe(map(r => r))
  }

  getBankStatementsAnalysis(params: {
    reference: string, // abn
    includeHistory?: boolean
  }): Observable<PayloadApiResponse<BankStatementData | null>> {
    return this.httpClient.post<PayloadApiResponse<BankStatementData | null>>(URL_GET_BANKSTATEMENTS_ANALYSIS(), params, httpOptions()).pipe();
  }

  getBankStatementAndBasiqDataStatusFn: GetBankStatementAndBasiqDataStatusFn = (reference: string, type: BasiqReferenceType) => {
    return this.getBankStatementAndBasiqDataStatus(reference, type).pipe(map(r => r))
  }

  getBankStatementAndBasiqDataStatus(reference: string, type: BasiqReferenceType): Observable<PayloadApiResponse<BankstatementAndBasiqDataStatus | null>> {
    return this.httpClient.get<PayloadApiResponse<BankstatementAndBasiqDataStatus | null>>(URL_GET_BANK_STATEMENT_AND_BASIQ_DATA_STATUS(reference, type), httpOptions()).pipe();
  }

  getBasiqCustomerMappingByAbnFn: GetBasiqCustomerMappingFn = (reference: string) => {
    return this.getBasiqCustomerMappingByAbn(reference).pipe(map(r => r))
  }

  getBasiqCustomerMappingByAbn(reference: string): Observable<PayloadApiResponse<BasiqUserCustomerMapping | null>> {
    return this.httpClient.get<PayloadApiResponse<BasiqUserCustomerMapping | null>>(URL_GET_BASIQ_CUSTOMER_MAPPING_BY_ABN(reference), httpOptions()).pipe();
  }

  getBasiqStatementDataForCompanyFn: GetBasiqStatementDataForCompanyFn = (params: BasiqUserCustomerMapping) => {
    return this.getBasiqStatementDataForCompany(params).pipe(map(r => r))
  }

  getBasiqStatementDataForCompany(params: BasiqUserCustomerMapping): Observable<PayloadApiResponse<BankStatementData | null>> {
    return this.httpClient.post<PayloadApiResponse<BankStatementData | null>>(URL_GET_BASIQ_STATEMENT_DATA_FOR_COMPANY(), params, httpOptions()).pipe();
  }

  checkActiveOverdraftAccount(abn: string): Observable<PayloadApiResponse<CheckActiveOverdraftAccountDetails>> {
    return this.httpClient.post<PayloadApiResponse<CheckActiveOverdraftAccountDetails>>(URL_CHECK_ACTIVE_OVERDRAFT_ACCOUNT(), { abn }, httpOptions());
  }

  refreshBankStatement(abn: string): Observable<PayloadApiResponse<Response | { Error: string }>> {
    return this.httpClient.get<PayloadApiResponse<Response | { Error: string }>>(URL_REFRESH_BANK_STATEMENT(abn), httpOptions());
  }

  refreshBankStatementFn = (abn: string): Observable<PayloadApiResponse<Response | { Error: string }>> => {
    return this.refreshBankStatement(abn);
  }

  getApplicationUserId(application: Application | null, user: User): number {
    return (application && application.UserId ? application.UserId : user.UserId);
  }

  getApplicationOriginatorBusinessId(application: Application | null, user: User): number | undefined {
    return (application && application.OriginatorBusinessId ? application.OriginatorBusinessId : user.OriginatorBusinessId);
  }

  getDocumentWorklist() {
    return this.httpClient.get<PayloadApiResponse<DocumentWorklists>>(URL_GET_DOCUMENT_WORKLIST(), httpOptions());
  }

  updateDocumentWorklist(worklist: DocumentWorklistTableData) {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_DOCUMENT_WORKLIST(), worklist, httpOptions());
  }

  createDocumentWorklist(worklist: DocumentWorklistTableData) {
    return this.httpClient.post<PayloadApiResponse<boolean>>(URL_CREATE_DOCUMENT_WORKLIST(), worklist, httpOptions());
  }

  createDocumentWorklistFn = (worklist: DocumentWorklistTableData): Observable<PayloadApiResponse<boolean>> => {
    return this.createDocumentWorklist(worklist);
  }

  completeDocumentWorklist(applicationId: number) {
    return this.httpClient.post<ApiResponse>(URL_COMPLETE_DOCUMENT_WORKLIST(applicationId), {}, httpOptions());
  }

  completeDocumentWorklistFn = (applicationId: number): Observable<ApiResponse> => {
    return this.completeDocumentWorklist(applicationId);
  }

  createNewDisbursement(disbursement: Disbursement): Observable<number> {
    return this.httpClient.post<PayloadApiResponse<number>>(URL_CREATE_NEW_DISBURSEMENT(), disbursement, httpOptions())
      .pipe(map(r => r.payload));
  }

  createNewDisbursementFn = (disbursement: Disbursement): Observable<number> => {
    return this.createNewDisbursement(disbursement);
  }

  updateDisbursement(disbursement: Disbursement): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_DISBURSEMENT(), disbursement, httpOptions());
  }

  updateDisbursementFn = (disbursement: Disbursement): Observable<ApiResponse> => {
    return this.updateDisbursement(disbursement);
  }

  getDisbursementByApplicationId<D extends Disbursement>(applicationId: number): Observable<D[]> {
    return this.httpClient.get<PayloadApiResponse<D[]>>(URL_GET_DISBURSEMENT_BY_APPLICATION_ID(applicationId), httpOptions())
      .pipe(map(response => response.payload));
  }

  getDisbursementByApplicationIdFn = <D extends Disbursement>(applicationId: number): Observable<D[]> => {
    return this.getDisbursementByApplicationId(applicationId);
  }

  syncDisbursementToSf(body: SyncDisbursementBody): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(URL_SYNC_DISBURSEMENT_TO_SF(), body, httpOptions());
  }

  syncDisbursementToSfFn = (body: SyncDisbursementBody): Observable<ApiResponse> => {
    return this.syncDisbursementToSf(body);
  }

  syncDepositPaidToSf = (body: SyncDepositPaidToBody): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_SYNC_DEPOSIT_PAID_TO_SF(), body, httpOptions())
  }

  syncDepositPaidToSfFn = (body: SyncDepositPaidToBody): Observable<ApiResponse> => {
    return this.syncDepositPaidToSf(body);
  }

  settleLoan(body: SettleLoanBody): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(URL_SETTLE_LOAN(), body, httpOptions());
  }

  settleLoanFn = (body: SettleLoanBody): Observable<ApiResponse> => {
    return this.settleLoan(body);
  }

  syncBankDetailsToSf(body: SyncSupplierBankDetailsBody): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(URL_SYNC_BANK_DETAILS_TO_SF(), body, httpOptions());
  }

  syncBankDetailsToSfFn = (body: SyncSupplierBankDetailsBody): Observable<ApiResponse> => {
    return this.syncBankDetailsToSf(body);
  }

  syncPrivateSellerBankDetailsToSf(body: SyncPrivateSellerBankDetailsBody): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(URL_SYNC_PRIVATE_SELLER_BANK_DETAILS_TO_SF(), body, httpOptions());
  }

  syncPrivateSellerBankDetailsToSfFn = (body: SyncPrivateSellerBankDetailsBody): Observable<ApiResponse> => {
    return this.syncPrivateSellerBankDetailsToSf(body);
  }

  getBillerName = (billerCode: string): Observable<PayloadApiResponse<BpayGetBillerByBillerCodeResult>> => {
    return this.httpClient.get<PayloadApiResponse<BpayGetBillerByBillerCodeResult>>(URL_GET_BPAY_BILLER_NAME_BY_BILLERCODE(billerCode), httpOptions());
  }

  getBillerNameFn = (billerCode: string): Observable<BpayGetBillerByBillerCodeResult> => {
    return this.getBillerName(billerCode).pipe(map(r => r.payload))
  }

  getInstitutionName = (bsb: string): Observable<PayloadApiResponse<DirectCreditInstitutionSearchResult | null>> => {
    return this.httpClient.get<PayloadApiResponse<DirectCreditInstitutionSearchResult>>(URL_GET_INSTITUTION_NAME(bsb), httpOptions())
  }

  getInstitutionNameFn = (bsb: string): Observable<DirectCreditInstitutionSearchResult | null> => {
    return this.getInstitutionName(bsb).pipe(map(r => r.payload))
  }

  validateBpay = (data: BpayValidationData): Observable<PayloadApiResponse<BpayValidatePaymentResult>> => {
    return this.httpClient.post<PayloadApiResponse<BpayValidatePaymentResult>>(URL_VALIDATE_BPAY(), data, httpOptions())
  }

  validateBpayFn = (data: BpayValidationData): Observable<BpayValidatePaymentResult> => {
    return this.validateBpay(data).pipe(map(r => r.payload))
  }

  updateApplicationStage(body: UpdateApplicationStageBody): Observable<ApiResponse> {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_APPLICATION_STAGE_IN_SF(), body, httpOptions());
  }

  updateApplicationStageFn = (body: UpdateApplicationStageBody): Observable<ApiResponse> => {
    return this.updateApplicationStage(body);
  }

  getBankDetailsFromOpportunitySf = (salesforceId: string): Observable<PayloadApiResponse<LocalBankAccountDetailValue | null>> => {
    return this.httpClient.get<PayloadApiResponse<LocalBankAccountDetailValue | null>>(URL_GET_BANK_DETAILS_FROM_OPPORTUNITY_SF(salesforceId), httpOptions())
  }

  getBankDetailsFromOpportunitySfFn = (salesforceId: string): Observable<LocalBankAccountDetailValue | null> => {
    return this.getBankDetailsFromOpportunitySf(salesforceId).pipe(map(r => r.payload));
  }
  generateApprovalNoticeFn = (body: GenerateApprovalNoticeBody): Observable<GenerateContractResponse> => {
    return this.httpClient.post<PayloadApiResponse<GenerateContractResponse>>(URL_GENERATE_APPROVAL_NOTICE(), body, httpOptions())
      .pipe(map((r: PayloadApiResponse<GenerateContractResponse>) => r.payload));
  }

  sendApprovalNoticeEmailFn = (body: SendApprovalNoticeEmailBody): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_SEND_APPROVAL_NOTICE_EMAIL(), body, httpOptions());
  }

  sendDocumentReviewEmailFn = (body: DocumentReviewEmailBody): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_SEND_DOCUMENT_REVIEW_EMAIL(), body, httpOptions());
  }

  deleteApprovalNoticeFileFn = (body: DeleteContractBody): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_DELETE_APPROVAL_NOTICE_FILE(), body, httpOptions());
  }

  getRbaRateFn: GetRbaRateFn = () => {
    return this.getRbaRate().pipe(map(r => r.payload));
  }

  getRbaRate() {
    return this.httpClient.get<PayloadApiResponse<number>>(URL_FETCH_RBA_RATES(), httpOptions());
  }

  /** @deprecated */
  getApplicationOwnerFn = (salesforceId: string): Observable<ApplicationOwner | null> => {
    return this.httpClient.get<PayloadApiResponse<ApplicationOwner | null>>(URL_GET_APPLICATION_OWNER(salesforceId), httpOptions())
      .pipe(map((r: PayloadApiResponse<ApplicationOwner | null>) => r.payload));
  }

  /** @deprecated */
  getApplicationCreditOfficerFn = (salesforceId: string): Observable<ApplicationCreditOfficer | null> => {
    return this.httpClient.get<PayloadApiResponse<ApplicationCreditOfficer | null>>(URL_GET_APPLICATION_CREDIT_OFFICER(salesforceId), httpOptions())
      .pipe(map((r: PayloadApiResponse<ApplicationCreditOfficer | null>) => r.payload));
  }

  getApplicationBySalesforceIdFn = (salesforceId: string): Observable<Application | null> => {
    return this.httpClient.get<PayloadApiResponse<Application | null>>(URL_GET_APPLICATION_BY_SALESFORCE_ID(salesforceId), httpOptions())
      .pipe(map((r: PayloadApiResponse<Application | null>) => r.payload));
  }

  deleteApplicationByAppId = (applicationId: number): Observable<ApiResponse> => {
    return this.httpClient.put<ApiResponse>(URL_DELETE_APPLICATION(applicationId), {}, httpOptions())
  }

  getAllApplicationSearch(opts: {
    page: { offset: number, limit: number, },
    filter: string,
    sorts?: ApplicationSortTypes,
  }): Observable<PaginablePayloadApiResponse<SimplifiedApplication>> {
    return this.httpClient.get<PaginablePayloadApiResponse<SimplifiedApplication>>(URL_ALL_APPLICATION_SEARCH(toPaginationInfo(opts)), httpOptions())
  }

  getAccountDetailsFromSfFn = (salesforceId: string): Observable<SfAccountDetails> => {
    return this.httpClient.get<PayloadApiResponse<SfAccountDetails>>(URL_GET_ACCOUNT_DETAILS_FROM_SF(salesforceId), httpOptions())
      .pipe(map(r => r.payload));
  }

  extractTaxInvoiceFn = async (file: File): Promise<Observable<TaxInvoiceDetails>> => {
    const base64Files = await filesToBase64Files([file]);
    console.log(base64Files);
    return this.httpClient.post<PayloadApiResponse<TaxInvoiceDetails>>(URL_EXTRACT_TAX_INVOICE(), {
      data: base64Files[0].base64.split(',')[1],
      type: file.type
    }, httpOptions())
      .pipe(map(r => r.payload));
  }

  getLvrCalculatorValue = (applicationId: number): Observable<PayloadApiResponse<LvrCalculatorValue>> => {
    return this.httpClient.get<PayloadApiResponse<LvrCalculatorValue>>(URL_GET_LVR_CALCULATOR_VALUE(applicationId), httpOptions());
  }

  getLvrCalculatorValueFn = (applicationId: number): Observable<LvrCalculatorValue> => {
    return this.getLvrCalculatorValue(applicationId).pipe(map(v => v.payload));
  }

  updateLvrCalculatorValueFn = (applicationId: number, input: LvrCalculatorInput): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_LVR_CALCULATOR_VALUE(applicationId), input, httpOptions());
  }

  getDscrCalculatorValue = (applicationId: number): Observable<PayloadApiResponse<DscrCalculatorValue>> => {
    return this.httpClient.get<PayloadApiResponse<DscrCalculatorValue>>(URL_GET_DSCR_CALCULATOR_VALUE(applicationId), httpOptions());
  }

  getDscrCalculatorValueFn = (applicationId: number): Observable<DscrCalculatorValue> => {
    return this.getDscrCalculatorValue(applicationId).pipe(map(v => v.payload));
  }

  updateDscrCalculatorValueFn = (applicationId: number, input: DscrCalculatorInput): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_DSCR_CALCULATOR_VALUE(applicationId), input, httpOptions());
  }

  createAssetInspectionFn = (assetId: number, applicationId: number, data: VerimotoAssetInspectionData): Observable<PayloadApiResponse<VerimotoCreateInspectionResponse>> => {
    return this.httpClient.post<PayloadApiResponse<VerimotoCreateInspectionResponse>>(URL_CREATE_ASSET_INSPECTION(), {
      data,
      assetId,
      applicationId
    }, httpOptions());
  }

  getAssetInspectionsForApplicationFn = (applicationId: number): Observable<VerimotoInspectionTableDataWithInspectionDetails[]> => {
    return this.httpClient.get<PayloadApiResponse<VerimotoInspectionTableDataWithInspectionDetails[]>>(URL_GET_ASSET_INSPECTIONS_FOR_APPLICATION(applicationId), httpOptions())
      .pipe(map((res: PayloadApiResponse<VerimotoInspectionTableDataWithInspectionDetails[]>) => res.payload));
  }

  downloadVerimotoReportFn = (encodedInspectionId: number): Observable<any> => {
    return this.httpClient.get<PayloadApiResponse<any>>(URL_DOWNLOAD_VERIMOTO_REPORT(encodedInspectionId), httpOptions())
      .pipe(map((res: PayloadApiResponse<any>) => res.payload))
  }

  // Container is chosen on the server. The optional argument remains so existing callers compile.
  downloadDocumentFromAzureFn = (file: string, _container?: AzureStorageContainer) => {
    return this.httpClient.post<PayloadApiResponse<{ type: "Buffer"; data: Buffer }>>(URL_DOWNLOAD_DOCUMENT_FROM_AZURE(), { file }, httpOptions())
      .pipe(map((res: PayloadApiResponse<{ type: "Buffer"; data: Buffer }>) => res.payload));
  }

  getActiveCreditUsers = (): Observable<UserOmitPriviledges[]> => {
    return this.httpClient.get<PayloadApiResponse<UserOmitPriviledges[]>>(URL_GET_ACTIVE_CREDIT_USERS(), httpOptions())
      .pipe(map((r: PayloadApiResponse<UserOmitPriviledges[]>) => r.payload));
  }

  getBsaLenderListFn = (): Observable<BsaLender[]> => {
    return this.httpClient.get<PayloadApiResponse<BsaLender[]>>(URL_GET_BSA_LENDER_LIST(), httpOptions())
      .pipe(map(response => response.payload));
  }

  getBsaExcludedLenderListFn = (): Observable<BsaLender[]> => {
    return this.httpClient.get<PayloadApiResponse<BsaLender[]>>(URL_GET_BSA_EXCLUDED_LENDER_LIST(), httpOptions())
      .pipe(map(response => response.payload));
  }

  updateBsaLenderFn = (data: UpdateLenderBody): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_BSA_LENDER(), data, httpOptions());
  }

  updateBsaExcludedLenderFn = (data: UpdateLenderBody): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_BSA_EXCLUDED_LENDER(), data, httpOptions());
  }

  saveBsaCalculatorFn = (data: SaveBsaCalculatorBody): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_BSA_SAVE_CALCULATOR(), data, httpOptions());
  }

  getBsaCalculatorFn = (applicationId: number): Observable<BsaCalculator | null> => {
    return this.httpClient.get<PayloadApiResponse<BsaCalculator | null>>(URL_BSA_GET_CALCULATOR(applicationId), httpOptions())
      .pipe(map(r => r.payload));
  }

  deleteBsaLenderFn = (id: number) => {
    return this.httpClient.post<ApiResponse>(URL_DELETE_BSA_LENDER(id), {}, httpOptions());
  }

  deleteBsaExcludedLenderFn = (id: number) => {
    return this.httpClient.post<ApiResponse>(URL_DELETE_BSA_EXCLUDED_LENDER(id), {}, httpOptions());
  }

  addBsaLenderFn = (data: AddLenderBody): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_ADD_BSA_LENDER(), data, httpOptions());
  }

  addBsaExcludedLenderFn = (data: AddLenderBody): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_ADD_BSA_EXCLUDED_LENDER(), data, httpOptions());
  }

  uploadBankStatementsFn = async (files: File[], applicationId: number): Promise<Observable<ApiResponse>> => {
    const base64Files = [...await filesToBase64Files(files)];
    const nf = base64Files.map(f => {
      return {
        base64: f.base64,
        name: f.name.replace(/[^\t\x20-\x7e\x80-\xff]/, '_'),
        size: f.size,
        type: f.type,
        tags: f?.tags ? [...f.tags, 'bankstatements'] : ['bankstatements'],
        metadata: f?.metadata ?? {}
      }
    });
    return this.httpClient.post<ApiResponse>(URL_UPLOAD_BANK_STATEMENTS(applicationId), {
      new: nf,
    }, { headers: { Authorization: '' } });
  }

  addCreditFlowFn = (data: NewCreditFlowBody): Observable<number> => {
    return this.httpClient.post<PayloadApiResponse<number>>(URL_ADD_CREDIT_FLOW(), data, httpOptions())
      .pipe(map(response => response.payload));
  }

  getCreditFlowsFn = (): Observable<CreditFlow[]> => {
    return this.httpClient.get<PayloadApiResponse<CreditFlow[]>>(URL_GET_CREDIT_FLOWS(), httpOptions())
      .pipe(map(response => response.payload));
  }

  updateCreditFlowFn = (data: UpdateCreditFlowBody, id: number): Observable<PayloadApiResponse<ConflictedFlowDetail[]>> => {
    return this.httpClient.post<PayloadApiResponse<ConflictedFlowDetail[]>>(URL_UPDATE_CREDIT_FLOW(id), data, httpOptions());
  }

  addCreditFlowNodeFn = (data: CreditFlowNodeBody): Observable<number> => {
    return this.httpClient.post<PayloadApiResponse<number>>(URL_ADD_CREDIT_FLOW_NODE(), data, httpOptions())
    .pipe(map(response => response.payload));
  }

  addCreditRuleMappingFn = (data: CreditRuleMappingBody): Observable<number> => {
    return this.httpClient.post<PayloadApiResponse<number>>(URL_ADD_CREDIT_RULE_MAPPING(), data, httpOptions())
    .pipe(map(response => response.payload));
  }

  getCreditFlowByIdFn = (flowId: number): Observable<CreditFlowDetails> => {
    return this.httpClient.get<PayloadApiResponse<CreditFlowDetails>>(URL_GET_CREDIT_FLOW_BY_ID(flowId), httpOptions())
    .pipe(map(response => response.payload));
  }

  updateCreditFlowNodeFn = (data: Partial<CreditFlowNode>, id: number): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_CREDIT_FLOW_NODE(id), data, httpOptions());
  }

  updateCreditRuleMappingFn = (data: Partial<CreditRuleMapping>, id: number): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_CREDIT_RULE_MAPPING(id), data, httpOptions());
  }

  runCreditFlowFn = (
    applicationId: number,
    startFromLastRun: boolean = false,
    productType?: 'FAST DOC' | 'EASY DOC' | 'FULL DOC'
  ): Observable<ApiResponse> => {
    const run$ = this.httpClient.get<ApiResponse>(URL_RUN_CREDIT_FLOW(applicationId, startFromLastRun), httpOptions());
    if (!productType) {
      return run$;
    }
    return this.httpClient.post<ApiResponse>(URL_UPDATE_APPLICATION_PRODUCT_TYPE(), {
      applicationId,
      productType,
    }, httpOptions()).pipe(
      switchMap((update) => update.status
        ? run$
        : throwError(() => new Error(update.message || 'Unable to update product type'))),
    );
  }

  // Privacy-consent gate check (US-10): resolves to the blocked payload when a guarantor signatory
  // lacks a valid consent, or null when the credit flow may run. Used by the Credit tab to show the
  // consent-required popup before the web-services selection dialog. Note: the backend persists a
  // stale-signature expiry as a side effect of this check (no consent is reissued).
  checkCreditFlowConsentBlockFn = (applicationId: number): Observable<CreditFlowConsentBlockPayload | null> => {
    return this.httpClient.get<PayloadApiResponse<CreditFlowConsentBlockPayload | null>>(URL_CHECK_CREDIT_FLOW_CONSENT_BLOCK(applicationId), httpOptions())
      .pipe(map(response => response.payload));
  }

  // CF auto-run rules: readiness of the manual Credit "Approve" action (all KYC passed + KYB
  // passed + credit flow run at least once). Drives the disabled state/tooltip of the Approve button.
  getCreditApprovalReadinessFn = (applicationId: number): Observable<CreditApprovalReadiness> => {
    return this.httpClient.get<PayloadApiResponse<CreditApprovalReadiness>>(URL_CREDIT_APPROVAL_READINESS(applicationId), httpOptions())
      .pipe(map(response => response.payload));
  }

  getKybRiskStatusFn = (applicationId: number): Observable<KybRiskStatus> => {
    return this.httpClient.post<PayloadApiResponse<KybRiskStatus>>(
      URL_GET_KYB_RISK_STATUS(),
      {applicationId},
      httpOptions(),
    ).pipe(map(response => response.payload));
  }

  getCreditAlertsFn = (): Observable<CreditAlert[]> => {
    return this.httpClient.get<PayloadApiResponse<CreditAlert[]>>(URL_GET_CREDIT_ALERTS(), httpOptions())
      .pipe(map(response => response.payload));
  }

  updateCreditAlertFn = (data: Partial<CreditAlert>, id: number): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_UDPATE_CREDIT_ALERT(id), data, httpOptions());
  }

  updateCreditStatusFn = (data: UpdateCreditStatusBody): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_CREDIT_STATUS(), data, httpOptions());
  }

  updateCreditOfficerFn = (data: UpdateCreditOfficerBody): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_CREDIT_OFFICER(), data, httpOptions());
  }

  addCreditAlertFn = (data: NewCreditAlertBody): Observable<number> => {
    return this.httpClient.post<PayloadApiResponse<number>>(URL_ADD_CREDIT_ALERT(), data, httpOptions())
      .pipe(map(response => response.payload));
  }

  getCreditAlertByStatusFn = (status: CreditAlertStatus): Observable<number> => {
    return this.httpClient.get<PayloadApiResponse<number>>(URL_GET_CREDIT_ALERT_BY_STATUS(status), httpOptions())
      .pipe(map(response => response.payload));
  }

  getDscrCalculatorHistoryFn = (applicationId: number): Observable<DscrCalculatorHistory[]> => {
    return this.httpClient.get<PayloadApiResponse<DscrCalculatorHistory[]>>(URL_BSA_GET_DSCR_CALCULATOR_HISTORY(applicationId), httpOptions())
      .pipe(map(response => response.payload));
  }

  copyCreditFlowFn = (data: CopyCreditFlowBody): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_COPY_CREDIT_FLOW(), data, httpOptions());
  }

  getCreditRuleItemsFn = (): Observable<CreditRuleItem[]> => {
    return this.httpClient.get<PayloadApiResponse<CreditRuleItem[]>>(URL_GET_CREDIT_RULE_ITEMS(), httpOptions())
      .pipe(map(response => response.payload));
  }

  updateCreditRuleItemFn = (data: Partial<CreditRuleItem>, id: number): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_UDPATE_CREDIT_RULE_ITEM(id), data, httpOptions());
  }

  addCreditRuleItemFn = (data: NewCreditRuleItemBody): Observable<number> => {
    return this.httpClient.post<PayloadApiResponse<number>>(URL_ADD_CREDIT_RULE_ITEM(), data, httpOptions())
      .pipe(map(response => response.payload));
  }

  publishCreditFlowFn = (data: Partial<PublishCreditFlowBody>, id: number): Observable<PayloadApiResponse<ConflictedFlowDetail[]>> => {
    return this.httpClient.post<PayloadApiResponse<ConflictedFlowDetail[]>>(URL_PUBLISH_CREDIT_FLOW(id), data, httpOptions());
  }

  getApplicationWebServicesFn = (applicationId: number, isSeeMore: boolean = false): Observable<NewWebService[]> => {
    return this.httpClient.get<PayloadApiResponse<NewWebService[]>>(URL_GET_COMMERCIAL_ENTITIES_INDIVIDUALS_WEB_SERVICES(applicationId, isSeeMore), httpOptions())
      .pipe(map(response => response.payload));
  }

  getApplicationCreditFlowResultFn = (applicationId: number): Observable<ApplicationCreditFlow[]> => {
    return this.httpClient.get<PayloadApiResponse<ApplicationCreditFlow[]>>(URL_GET_APPLICATION_CREDIT_FLOW_RESULT(applicationId), httpOptions())
      .pipe(map(response => response.payload));
  }

  getHistoricalContractsFn = (applicationId: number): Observable<HistoricalContract[]> => {
    return this.httpClient.get<PayloadApiResponse<HistoricalContract[]>>(URL_GET_HISTORICAL_CONTRACTS(applicationId), httpOptions())
      .pipe(map(response => response.payload));
  }

  getPismoContractsFn: GetPismoContractsFn = (applicationId: number): Observable<PismoContract[]> => {
    return this.httpClient.get<PayloadApiResponse<PismoContract[]>>(URL_GET_PISMO_CONTRACTS(applicationId), httpOptions())
      .pipe(map(response => response.payload));
  }

  downloadCreditorWatchReportFn = (pdfId: number): Observable<any> => {
    return this.httpClient.get<PayloadApiResponse<any>>(URL_DOWNLOAD_CREDITORWATCH_REPORT(pdfId), httpOptions())
      .pipe(map((res: PayloadApiResponse<any>) => res.payload))
  }

  getApplicationKybRunsFn = (opts: {
    page: { offset: number, limit: number },
    filter: string,
    sorts?: { prop: string, dir: 'asc' | 'desc' }[] | null,
    filters: ApplicationKybRunFilters,
  }): Observable<ApplicationKybQueueResponse> => {
    return this.httpClient.get<ApplicationKybQueueResponse>(
      URL_GET_APPLICATION_KYB_RUNS(toPaginationInfo(opts), opts.filters), httpOptions())
  }

  retryApplicationKybRunsFn = (applicationKybRunIds: number[]): Observable<PayloadApiResponse<RetryApplicationKybRunsResult>> => {
    return this.httpClient.post<PayloadApiResponse<RetryApplicationKybRunsResult>>(
      URL_RETRY_APPLICATION_KYB_RUNS(), { applicationKybRunIds }, httpOptions())
  }

  retryKybReevaluationFn = (applicationKybRunId: number): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(
      URL_RETRY_KYB_REEVALUATION(), { applicationKybRunId }, httpOptions())
  }

  getAmlDashboardFn = (opts: {
    page: { offset: number, limit: number },
    sorts?: AmlDashboardSort[] | null,
    filters: AmlDashboardFilters,
  }): Observable<AmlDashboardResponse> => {
    return this.httpClient.get<AmlDashboardResponse>(
      URL_GET_AML_DASHBOARD(toPaginationInfo(opts), opts.filters), httpOptions());
  }

  /** `truncated` is true when the server capped the export at AML_DASHBOARD_CSV_MAX_ROWS. */
  downloadAmlDashboardCsv = (filters: AmlDashboardFilters, sort: AmlDashboardSort | null = null): Observable<{ blob: Blob, truncated: boolean }> => {
    return this.httpClient.get(URL_DOWNLOAD_AML_DASHBOARD_CSV(filters, sort), {
      ...httpOptions(),
      observe: 'response',
      responseType: 'blob',
    }).pipe(map(response => ({
      blob: response.body ?? new Blob([], { type: 'text/csv' }),
      truncated: response.headers.get('X-Aml-Csv-Truncated') === 'true',
    })));
  }

  getAmlOfficerCandidatesFn: GetAmlOfficerCandidatesFn = (): Observable<AmlOfficerCandidate[]> => {
    return this.httpClient.get<PayloadApiResponse<AmlOfficerCandidate[]>>(URL_GET_AML_OFFICER_CANDIDATES(), httpOptions())
      .pipe(map(response => response.payload));
  }

  updateAmlOfficerFn: UpdateApplicationAmlOfficerFn = (body: UpdateAmlOfficerForApplication): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_AML_OFFICER_FOR_APPLICATION(), body, httpOptions());
  }

  getCreditAuditLogFn = (applicationId: number, opts:{
    page: { offset: number, limit: number,},
    filter: string,
  }): Observable<PaginablePayloadApiResponse<CreditAuditLog>> => {
    return this.httpClient.get<PaginablePayloadApiResponse<CreditAuditLog>>(URL_GET_CREDIT_AUDIT_LOG(applicationId, toPaginationInfo(opts)), httpOptions())
  }

  getWebServiceReportFn = (webServiceId: number): Observable<GetWebServiceReportResponse> => {
    return this.httpClient.get<PayloadApiResponse<GetWebServiceReportResponse>>(URL_GET_WEB_SERVICE_REPORT(webServiceId), httpOptions())
    .pipe(map((res: PayloadApiResponse<GetWebServiceReportResponse>) => res.payload))
  }

  getDuplicatedApplicationsFn = (applicationId: number): Observable<DuplicatedApplication[]> => {
    return this.httpClient.get<PayloadApiResponse<DuplicatedApplication[]>>(URL_GET_DUPLCIATED_APPLICATIONS(applicationId), httpOptions())
    .pipe(map((res: PayloadApiResponse<DuplicatedApplication[]>) => res.payload))
  }

  deleteWebServicesFn = (webServiceIds: number[]): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_DELETE_WEB_SERVICES(), {webServiceIds}, httpOptions());
  }
  requestMoreInformationFn = (body: RequestMoreInformationBody): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_CREDIT_MORE_INFORMATION(), body, httpOptions());
  }

  withdrawApplicationFn = (body: WithdrawApplicationBody): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_WITHDRAW_APPLICATION(), body, httpOptions());
  }

  getApplicationDscrFn = (applicationId: number): Observable<number> => {
    return this.httpClient.get<PayloadApiResponse<number>>(URL_GET_APPLICATION_DSCR(applicationId), httpOptions())
    .pipe(map((res: PayloadApiResponse<number>) => res.payload))
  }

  getApplicationExposureFn = (applicationId: number): Observable<number> => {
    return this.httpClient.get<PayloadApiResponse<number>>(URL_GET_APPLICATION_EXPOSURE(applicationId), httpOptions())
    .pipe(map((res: PayloadApiResponse<number>) => res.payload))
  }

  recalculateExposureAtSubmissionFn = (applicationId: number): Observable<number> => {
    return this.httpClient.post<PayloadApiResponse<number>>(URL_RECALCULATE_EXPOSURE_AT_SUBMISSION(applicationId), {}, httpOptions())
    .pipe(map((res: PayloadApiResponse<number>) => res.payload))
  }

  getSatisfactoryConductFn = (applicationId: number): Observable<string> => {
    return this.httpClient.get<PayloadApiResponse<string>>(URL_GET_SATISFACTORY_CONDUCT(applicationId), httpOptions())
    .pipe(map((res: PayloadApiResponse<string>) => res.payload))
  }

  getApplicationSettlementsOfficerFn = (): Observable<SearchableSelectItem[]> => {
    return this.httpClient.get<PayloadApiResponse<SearchableSelectItem[]>>(URL_GET_APPLICATION_SETTLEMENTS_OFFICER(), httpOptions())
      .pipe(map((r: PayloadApiResponse<SearchableSelectItem[]>) => r.payload));
  }
  
  updateSettlementsOfficerFn = (body: UpdateSettlementsOfficerForApplication): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_SETTLEMENTS_OFFICER_FOR_APPLICATION(), body, httpOptions());
  }

  updateConnectionToOtherCreditFlowFn = (body: ConnectToOtherCreditFlowBody): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_UPDATE_CONNECTION_TO_OTHER_CREDIT_FLOW(), body, httpOptions());
  }

  clearConnectionToOtherCreditFlowFn = (body: ClearConnectToOtherCreditFlowBody): Observable<ApiResponse> => {
    return this.httpClient.post<ApiResponse>(URL_CLEAR_CONNECTION_TO_OTHER_CREDIT_FLOW(), body, httpOptions());
  }

  testCreditRuleFn = (body: TestCreditRuleBody): Observable<TestCreditFlowResponse> => {
    return this.httpClient.post<PayloadApiResponse<TestCreditFlowResponse>>(URL_TEST_CREDIT_RULE(), body, httpOptions())
    .pipe(map(response => response.payload));
  }

  testCreditFlowFn = (body: TestCreditFlowBody): Observable<TestCreditFlowResponse> => {
    return this.httpClient.post<PayloadApiResponse<TestCreditFlowResponse>>(URL_TEST_CREDIT_FLOW(), body, httpOptions())
    .pipe(map(response => response.payload));
  }

  testCreditFlowNodeFn = (body: TestCreditFlowNodeBody): Observable<TestCreditFlowResponse> => {
    return this.httpClient.post<PayloadApiResponse<TestCreditFlowResponse>>(URL_TEST_CREDIT_FLOW_NODE(), body, httpOptions())
    .pipe(map(response => response.payload));
  }

  testCreditRuleItemFn = (body: TestCreditRuleItemBody): Observable<TestCreditFlowResponse> => {
    return this.httpClient.post<PayloadApiResponse<TestCreditFlowResponse>>(URL_TEST_CREDIT_RULE_ITEM(), body, httpOptions())
    .pipe(map(response => response.payload));
  }

  setApplicationToDraftFn = (applicationId: number): Observable<ApiResponse> => {
    return this.httpClient.put<ApiResponse>(URL_SET_APPLICATION_TO_DRAFT(applicationId), {}, httpOptions());
  }

  getDeadletteredSalesforceJobsFn: GetDeadletteredSalesforceJobsFn = (recordType: SalesforceSyncRecordType, recordId: number) => {
    return this.httpClient.get<PayloadApiResponse<DeadletteredSalesforceJob[]>>(URL_GET_DEADLETTERED_SALESFORCE_JOBS_FOR_RECORD(recordType, recordId), httpOptions())
      .pipe(map(r => r.payload ?? []));
  }

  requeueDeadletteredSalesforceJobFn: RequeueDeadletteredSalesforceJobFn = (correlationId: string) => {
    return this.httpClient.post<ApiResponse>(URL_REQUEUE_DEADLETTERED_SALESFORCE_JOB(), { correlationId }, httpOptions());
  }
}

